// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaDownload, FaPlus } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { FaEye, FaEdit } from "react-icons/fa";
// import { BsThreeDots } from "react-icons/bs";
// import { MdAirplanemodeInactive, MdAirplanemodeActive } from "react-icons/md";
// import { RiDeleteBin5Fill } from "react-icons/ri";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function AllLeadList() {
//   const navigate = useNavigate();
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchOrder, setSearchOrder] = useState("");
//   const [searchMobile, setSearchMobile] = useState("");
//   const [searchPlotName, setSearchPlotName] = useState("");
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showResponceModal, setShowResponceModal] = useState(false);
//   const [loadingEdit, setLoadingEdit] = useState(false);
//   const [loadingResponce, setLoadingResponce] = useState(false);
//   const [leadId, setLeadId] = useState(null);
//   const [orderId, setOrderId] = useState(null);
//   const [responseText, setResponseText] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [documentFile, setDocumentFile] = useState([]);
//   const [exporting, setExporting] = useState(false);
//   const [userId, setUserId] = useState(null);
//   const [statusUpdateDate, setStatusUpdateDate] = useState("");

//   const userType = localStorage.getItem("userType");

//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     project_id: "",
//     block_id: "",
//     plot_id: "",
//     customer_name: "",
//     mobile: "",
//     income_source: "",
//     adhar_card_number: "",
//     pan_card_number: "",
//     adharfront: null,
//     adharback: null,
//     pancard: null,
//     lead_date: "",
//   });

//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   const incomeSourceOptions = [
//     { value: "", label: "Select Income Source" },
//     { value: "business", label: "Business" },
//     { value: "salaried", label: "Salaried" },
//     { value: "rent", label: "Rent" },
//     { value: "pension", label: "Pension" },
//     { value: "other", label: "Other" },
//   ];

//   const [projectsForEdit, setProjectsForEdit] = useState([]);
//   const [blocksForEdit, setBlocksForEdit] = useState([]);
//   const [plotsForEdit, setPlotsForEdit] = useState([]);
//   const [loadingDropdowns, setLoadingDropdowns] = useState(false);
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//     showDateInput: false,
//     status: "",
//     selectedDate: "",
//   });

//   const showCustomMessageModal = (
//     title,
//     text,
//     type,
//     confirmAction = null,
//     showDateInput = false,
//     status = "",
//   ) => {
    
//     if (
//       showDateInput &&
//       (status === "approved" || status === "unitisnotsold")
//     ) {
//       setStatusUpdateDate(new Date().toISOString().split("T")[0]);
//     } else {
//       setStatusUpdateDate("");
//     }

//     setMessageModalContent({
//       title,
//       text,
//       type,
//       confirmAction,
//       showDateInput,
//       status,
//     });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = (keepDate = false) => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//       showDateInput: false,
//       status: "",
//       selectedDate: "",
//     });
//     if (!keepDate) {
//       setStatusUpdateDate("");
//     }
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const allowedDomains = [
//     "admin.rajasthanirealestates.in",
//     "realestateadmin.a2logicgroup.com",
//     "master.bahikhatas.com"
//   ];

//   const dontallowedDomains = ["master.bahikhatas.com"];

//   const currentDomain = window.location.host;

//   useEffect(() => {
//     const fetchProjectsListForEdit = async () => {
//       setLoadingDropdowns(true);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal(
//             "Authentication Error",
//             "Authentication token not found. Please log in.",
//             "error",
//           );
//           setLoadingDropdowns(false);
//           return;
//         }

//         const response = await fetch(`${API_URL}/project-list-block`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           showCustomMessageModal(
//             "Error",
//             errorData.message || "Failed to fetch projects for dropdown.",
//             "error",
//           );
//           setLoadingDropdowns(false);
//           return;
//         }

//         const data = await response.json();
//         setProjectsForEdit(data.data || []);
//       } catch (err) {
//         console.error("Fetch projects for edit error:", err);
//         showCustomMessageModal(
//           "Error",
//           err.message ||
//           "An unexpected error occurred while fetching projects for edit.",
//           "error",
//         );
//       } finally {
//         setLoadingDropdowns(false);
//       }
//     };

//     fetchProjectsListForEdit();
//   }, []);

//   useEffect(() => {
//     const fetchBlocksListForEdit = async () => {
//       if (editFormData.project_id) {
//         setLoadingDropdowns(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             setLoadingDropdowns(false);
//             return;
//           }

//           const response = await fetch(`${API_URL}/block-list-plot`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ project_id: editFormData.project_id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch blocks for dropdown.",
//               "error",
//             );
//             setBlocksForEdit([]);
//             setLoadingDropdowns(false);
//             return;
//           }

//           const data = await response.json();
//           setBlocksForEdit(data.data || []);
//         } catch (err) {
//           console.error("Fetch blocks for edit error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message ||
//             "An unexpected error occurred while fetching blocks for edit.",
//             "error",
//           );
//           setBlocksForEdit([]);
//         } finally {
//           setLoadingDropdowns(false);
//         }
//       } else {
//         setBlocksForEdit([]);
//         setPlotsForEdit([]);
//       }
//     };

//     fetchBlocksListForEdit();
//   }, [editFormData.project_id]);

//   useEffect(() => {
//     const fetchPlotsForEdit = async () => {
//       if (editFormData.block_id) {
//         setLoadingDropdowns(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             setLoadingDropdowns(false);
//             return;
//           }

//           const response = await fetch(`${API_URL}/property-lead-plot-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ block_id: editFormData.block_id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch units for dropdown.",
//               "error",
//             );
//             setPlotsForEdit([]);
//             setLoadingDropdowns(false);
//             return;
//           }

//           const data = await response.json();
//           setPlotsForEdit(data.data || []);
//         } catch (err) {
//           console.error("Fetch units for edit error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message ||
//             "An unexpected error occurred while fetching units for edit.",
//             "error",
//           );
//           setPlotsForEdit([]);
//         } finally {
//           setLoadingDropdowns(false);
//         }
//       } else {
//         setPlotsForEdit([]);
//       }
//     };

//     fetchPlotsForEdit();
//   }, [editFormData.block_id]);

//   const fetchLeads = async (
//     page = 1,
//     query = "",
//     orderid = "",
//     mobile = "",
//     status = "",
//     plotname = "",
//   ) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         setLoading(false);
//         return;
//       }

//       let url = `${API_URL}/property-lead-list?page=${page}&limit=10`;
//       if (mobile) url += `&mobile=${mobile}`;
//       if (query) url += `&name=${query}`;
//       if (orderid) url += `&orderid=${orderid}`;
//       if (plotname) url += `&plotname=${plotname}`;
//       if (status) url += `&status=${status}`;

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal(
//             "Authorization Error",
//             "Unauthorized: Please log in again.",
//             "error",
//           );
//         }
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch leads.");
//       }

//       const data = await response.json();

//       setLeads(data.data || []);
//       setUserId(data?.data?.length > 0 ? data.data[0].creater_id : null);
//       setTotalPages(data.totalPages || 1);
//       setCurrentPage(data.currentPage || page);
//     } catch (err) {
//       console.error("Fetch leads error:", err);
//       setError(err.message);
//       if (!showMessageModal) {
//         showCustomMessageModal(
//           "Error",
//           err.message || "An unexpected error occurred while fetching leads.",
//           "error",
//         );
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeads(currentPage);
//   }, [currentPage]);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleSearchOrder = (e) => {
//     setSearchOrder(e.target.value);
//   };

//   const handleSearchChangeLocation = (e) => {
//     setSearchMobile(e.target.value);
//   };

//   const handleSearchChangesearchPlotName = (e) => {
//     setSearchPlotName(e.target.value);
//   };

//   const handleSearchClick = () => {
//     setCurrentPage(1);
//     fetchLeads(
//       1,
//       searchQuery.trim(),
//       searchOrder,
//       searchMobile.trim(),
//       statusFilter,
//       searchPlotName.trim(),
//     );
//   };

//   const handleClearSearch = () => {
//     setSearchQuery("");
//     setSearchOrder("");
//     setSearchMobile("");
//     setSearchPlotName("");
//     setStatusFilter("");
//     setCurrentPage(1);
//     fetchLeads(1, "", "", "", "", "");
//   };

//   const handleStatusFilterChange = (status) => {
//     setStatusFilter(status);
//     setCurrentPage(1);
//     fetchLeads(
//       1,
//       searchQuery.trim(),
//       searchOrder,
//       searchMobile.trim(),
//       status,
//       searchPlotName.trim(),
//     );
//   };

//   const handleViewLead = async (id) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/property-lead-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch lead details.",
//           "error",
//         );
//         setLoading(false);
//         return;
//       }

//       const data = await response.json();
//       setSelectedLead(data.data);
//       setShowViewModal(true);
//     } catch (err) {
//       showCustomMessageModal(
//         "Error",
//         "An error occurred while fetching lead details.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };



//   const handleEditLead = async (id) => {
//     setLoadingEdit(true);
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/property-lead-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch lead details for edit.",
//           "error",
//         );
//         setLoadingEdit(false);
//         return;
//       }

//       const data = await response.json();
//       const leadData = data.data;

//       let formattedDate = "";
//       if (leadData.date) {
//         const [day, month, year] = leadData.date.split("-");
//         formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
//       }

//       setEditFormData({
//         id: leadData.id,
//         project_id: leadData.project_id,
//         block_id: leadData.block_id,
//         plot_id: leadData.plot_id,
//         customer_name: leadData.customer_name,
//         mobile: leadData.mobile,
//         income_source: leadData.income_source,
//         adhar_card_number: leadData.adhar_card_number,
//         pan_card_number: leadData.pan_card_number,
//         adharfront: leadData.adhar_front_image || null,
//         adharback: leadData.adhar_back_image || null,
//         pancard: leadData.pan_card_image || null,
//         lead_date: formattedDate,
//       });

//       setShowEditModal(true);
//     } catch (err) {
//       showCustomMessageModal(
//         "Error",
//         "An unexpected error occurred while fetching lead details for edit.",
//         "error",
//       );
//     } finally {
//       setLoadingEdit(false);
//     }
//   };

//   const handleResponseLead = async (id, orderid) => {
//     setLoadingResponce(true);
//     try {
//       setLeadId(id);
//       setOrderId(orderid);
//       setShowResponceModal(true);
//     } catch (err) {
//       showCustomMessageModal(
//         "Error",
//         "An unexpected error occurred while fetching lead details for edit.",
//         "error",
//       );
//     } finally {
//       setLoadingResponce(false);
//     }
//   };

//   const handleSubmitResponse = async (e) => {
//     e.preventDefault();
//     setLoadingResponce(true);
//     try {
//       const token = getAuthToken();
//       const formData = new FormData();
//       formData.append("lead_id", leadId);
//       formData.append("response", responseText);

//       documentFile.forEach((file) => {
//         formData.append("document", file);
//       });

//       const response = await fetch(`${API_URL}/property-lead-response-store`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       const data = await response.json();
//       if (response.ok) {
//         showCustomMessageModal(
//           "Success",
//           "Response submitted successfully",
//           "success",
//         );
//         setShowResponceModal(false);
//         setResponseText("");
//         setDocumentFile([]);
//       } else {
//         throw new Error(data.message || "Failed to submit response");
//       }

//       if (socket && socket.readyState === WebSocket.OPEN) {
//         const notificationPayload = {
//           user_id: userId,
//           type: "property_lead",
//           message: `A response has been added for Property Lead ${leadId}.`,
//           statusremark: null,
//           remark: responseText,
//           order_id: orderId,
//           action_by: "admin",
//           date: new Date().toISOString(),
//         };
//         socket.send(JSON.stringify(notificationPayload));
//         console.warn("notificationPayload", notificationPayload);
//       }
//     } catch (err) {
//       showCustomMessageModal("Error", err.message, "error");
//     } finally {
//       setLoadingResponce(false);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files && files.length > 0) {
//       setEditFormData((prevData) => ({ ...prevData, [name]: files[0] }));
//     } else {
//       setEditFormData((prevData) => ({ ...prevData, [name]: value }));
//     }
//   };

//   const [validationErrors, setValidationErrors] = useState({
//     project_id: "",
//     block_id: "",
//     plot_id: "",
//     customer_name: "",
//     mobile: "",
//     adhar_card_number: "",
//     pan_card_number: "",
//     adharfront: "",
//     adharback: "",
//     pancard: "",
//     lead_date: "",
//   });

//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;

//     if (!editFormData.project_id) {
//       errors.project_id = "Project is required";
//       isValid = false;
//     }

//     if (!editFormData.block_id) {
//       errors.block_id = "Block is required";
//       isValid = false;
//     }

//     if (!editFormData.plot_id) {
//       errors.plot_id = "Unit is required";
//       isValid = false;
//     }

//     if (
//       !editFormData.customer_name ||
//       editFormData.customer_name.trim() === ""
//     ) {
//       errors.customer_name = "Customer name is required";
//       isValid = false;
//     }

//     if (!editFormData.mobile) {
//       errors.mobile = "Mobile number is required";
//       isValid = false;
//     } else if (!/^\d{10}$/.test(editFormData.mobile)) {
//       errors.mobile = "Mobile number must be 10 digits";
//       isValid = false;
//     }

//     if (!editFormData.adhar_card_number) {
//       errors.adhar_card_number = "Aadhaar number is required";
//       isValid = false;
//     } else if (!/^\d{12}$/.test(editFormData.adhar_card_number)) {
//       errors.adhar_card_number = "Aadhaar must be 12 digits";
//       isValid = false;
//     }

//     if (!editFormData.pan_card_number) {
//       errors.pan_card_number = "PAN number is required";
//       isValid = false;
//     } else if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(editFormData.pan_card_number)) {
//       errors.pan_card_number = "Invalid PAN format (e.g., ABCDE1234F)";
//       isValid = false;
//     }

//     if (
//       editFormData.adharfront &&
//       typeof editFormData.adharfront !== "string"
//     ) {
//       if (editFormData.adharfront.size > 2 * 1024 * 1024) {
//         errors.adharfront = "File size must be less than 2MB";
//         isValid = false;
//       }
//       if (
//         !["image/jpeg", "image/png", "application/pdf"].includes(
//           editFormData.adharfront.type,
//         )
//       ) {
//         errors.adharfront = "Only JPEG, PNG, or PDF files are allowed";
//         isValid = false;
//       }
//     }
//     setValidationErrors(errors);
//     return isValid;
//   };

//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) {
//       return;
//     }
//     setLoadingEdit(true);
//     try {
//       const token = getAuthToken();
//       const formData = new FormData();

//       for (const key in editFormData) {
//         if (editFormData[key] !== null) {
//           if (typeof editFormData[key] !== "string") {
//             formData.append(key, editFormData[key]);
//           } else if (
//             key !== "adharfront" &&
//             key !== "adharback" &&
//             key !== "pancard"
//           ) {
//             formData.append(key, editFormData[key]);
//           }
//         }
//       }

//       const selectedProject = projectsForEdit.find(
//         (p) => p.id === parseInt(editFormData.project_id),
//       );
//       if (selectedProject)
//         formData.append("project_name", selectedProject.name);

//       const selectedBlock = blocksForEdit.find(
//         (b) => b.id === parseInt(editFormData.block_id),
//       );
//       if (selectedBlock) formData.append("block_name", selectedBlock.name);

//       const selectedPlot = plotsForEdit.find(
//         (p) => p.id === parseInt(editFormData.plot_id),
//       );
//       if (selectedPlot)
//         formData.append("plot_name", selectedPlot.plot_shop_villa_no);

//       const response = await fetch(`${API_URL}/property-lead-update`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update lead.");
//       }

//       const result = await response.json();

//       if (result.success == "1") {
//         showCustomMessageModal(
//           "Success",
//           result.message || "Lead updated successfully.",
//           "success",
//         );
//         setShowEditModal(false);
//         fetchLeads(currentPage, searchQuery);
//       } else {
//         showCustomMessageModal("Error", result.message, "error");
//       }
//     } catch (err) {
//       showCustomMessageModal("Error", err.message, "error");
//     } finally {
//       setLoadingEdit(false);
//     }
//   };

//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     const ws = new WebSocket(process.env.REACT_APP_WS_URL);

//     ws.onopen = () => {
//       console.log("WebSocket connection established");
//     };

//     ws.onmessage = (event) => {
//       try {
//         const data = JSON.parse(event.data);
//         console.log("Message from server:", data);
//       } catch (e) {
//         console.log("Raw message:", event.data);
//       }
//     };

//     ws.onclose = () => {
//       console.log("WebSocket disconnected");
//     };

//     ws.onerror = (err) => {
//       console.error("WebSocket error:", err);
//     };

//     setSocket(ws);

//     return () => ws.close();
//   }, []);

//   const bookProperty = async (projectId, blockId, plotId, userId) => {
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/book-now`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           project_id: projectId,
//           block_id: blockId,
//           plot_id: plotId,
//           user_id: userId,
//         }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to book the property.");
//       }
//       const result = await response.json();
//       showCustomMessageModal(
//         "Success",
//         result.message || "Property booked successfully.",
//         "success",
//       );
//     } catch (err) {
//       console.error("Book property error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "An error occurred while booking the property.",
//         "error",
//       );
//     }
//   };

//   const handleStatusUpdate = (lead, newStatus) => {
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Are you sure you want to change the status to ${formatStatus(newStatus)} on ${lead.date} Lead Date?`,
//       "confirmation",
//       async (selectedDate) => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const payload = {
//             id: lead.id,
//             status: newStatus,
//           };
//           if (
//             (newStatus === "approved" || newStatus === "unitisnotsold") &&
//             selectedDate
//           ) {
//             payload.status_date = selectedDate;
//           }

//           console.log("Sending payload:", payload);

//           const response = await fetch(
//             `${API_URL}/property-lead-update-status`,
//             {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//               },
//               body: JSON.stringify(payload),
//             },
//           );

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(
//               errorData.message || "Failed to update lead status.",
//             );
//           }

//           const result = await response.json();

//           closeCustomMessageModal();
//           showCustomMessageModal(
//             "Success",
//             result.message || "Lead status updated successfully.",
//             "success",
//           );
//           fetchLeads(currentPage, searchQuery);

//           if (newStatus === "approved") {
//             await bookProperty(
//               lead.project_id,
//               lead.block_id,
//               lead.plot_id,
//               lead.creater_id,
//             );
//           }

//           if (socket && socket.readyState === WebSocket.OPEN) {
//             const notificationPayload = {
//               user_id: userId,
//               type: "loan_lead",
//               message: `Loan lead ${lead.order_id} status changed to ${newStatus}.`,
//               statusremark: newStatus,
//               remark: null,
//               order_id: lead.order_id,
//               action_by: "admin",
//               date: new Date().toISOString(),
//               status_date:
//                 newStatus === "approved" || newStatus === "unitisnotsold"
//                   ? selectedDate
//                   : null,
//             };
//             socket.send(JSON.stringify(notificationPayload));
//           }
//         } catch (err) {
//           closeCustomMessageModal();
//           showCustomMessageModal(
//             "Error",
//             err.message || "An error occurred while updating status.",
//             "error",
//           );
//         } finally {
//           setLoading(false);
//         }
//       },
//       newStatus === "approved" || newStatus === "unitisnotsold",
//       newStatus,
//     );
//   };

//   const handleDeleteLead = (id) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this lead? This action cannot be undone.",
//       "confirmation",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const response = await fetch(`${API_URL}/property-lead-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete lead.");
//           }

//           const result = await response.json();
//           showCustomMessageModal(
//             "Success",
//             result.message || "Lead deleted successfully.",
//             "success",
//           );
//           fetchLeads(currentPage, searchQuery);
//         } catch (err) {
//           showCustomMessageModal(
//             "Error",
//             err.message || "An error occurred while deleting lead.",
//             "error",
//           );
//         } finally {
//           setLoading(false);
//           closeCustomMessageModal();
//         }
//       },
//     );
//   };

//   const handleRemarkList = (leadId, orderid, userId) => {
//     navigate(`/lead-remarks/${leadId}/${orderid}/${userId}`);
//   };

//   const getStatusBadgeClass = (status) => {
//     const classes = {
//       pending: "bg-warning text-white",
//       inprocess: "bg-info text-white",
//       approved: "bg-success text-white",
//       available: "bg-success text-dark",
//       sold: "bg-danger",
//       new: "bg-warning text-white",
//       unitisnotsold: "bg-danger",
//     };
//     return classes[status] || "bg-secondary";
//   };

//   const formatStatus = (status) => {
//     const statusMap = {
//       new: "New",
//       documentPending: "Document Pending",
//       paymentPending: "Payment Pending",
//       notInterested: "Not Interested",
//       loanInprocess: "Loan In Process",
//       pattaInprocess: "Patta In Process",
//       termSheetPending: "Term Sheet Pending",
//       agreementSignaturePending: "Agreement Signature Pending",
//       pattaApplicationFormPending: "Patta Application Form Pending",
//       approved: "Approved",
//       unitisnotsold: "Unit is not sold",
//       rejected: "Rejected",
//     };
//     return statusMap[status] || status;
//   };

//   const exportAllToExcel = async () => {
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         alert("Please login!");
//         return;
//       }

//       let url = `${API_URL}/lead-properties-new-exceldownload`;

//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "text/csv",
//         },
//       });

//       if (!response.ok) {
//         alert("Server Error: Unable to download!");
//         return;
//       }

//       const csvData = await response.text();

//       const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.setAttribute("download", `projects_${Date.now()}.csv`);
//       link.click();
//     } catch (error) {
//       console.error("CSV Export Error:", error);
//       alert("Export Failed! Try again");
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{ minHeight: "80vh" }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="alert alert-danger text-center m-5" role="alert">
//         {error}
//         <button className="btn btn-primary ms-3" onClick={() => fetchLeads()}>
//           Retry
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="userlist mt-2">
//       <div className="card">
//         <div className="card-header">
//           <div className="d-flex flex-wrap-mobile gap-2 align-items-center justify-content-between">
//             <div className="titlepage">
//               <h3>All Property Lead</h3>
//             </div>
//             <div className="d-flex gap-2 flex-wrap-mobile align-items-center justify-content-between">
              
//                 <div className="createnewadmin">
//                   <button
//                     className="exportexcel btn gap-2 btn-success d-inline-flex align-items-center"
//                     onClick={exportAllToExcel}
//                     disabled={exporting}
//                   >
//                     <FaDownload />
//                     {exporting ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm me-2"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                         Exporting All...
//                       </>
//                     ) : (
//                       "Export"
//                     )}
//                   </button>
//                 </div>
              
//               <div className="createnewadmin">
//                 <Link
//                   to="/create-lead"
//                   className="btn btn-success d-flex align-items-center"
//                 >
//                   <FaPlus className="me-2" /> Add Lead
//                 </Link>
//               </div>
//               <>
//                 <div className="createnewadmin">
//                   <Link
//                     to="/create-lead-by-uploading-csv"
//                     className="btn btn-success d-inline-flex align-items-center"
//                   >
//                     <FaPlus className="me-2" /> Upload CSV
//                   </Link>
//                 </div>

//               </>
//               <button
//                 className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//                 onClick={handleToggle}
//               >
//                 {isFilterActive ? (
//                   <>
//                     <MdFilterAltOff />
//                   </>
//                 ) : (
//                   <>
//                     <MdFilterAlt />
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="card-body">
//           {isFilterActive && (
//             <div className="d-flex gap-2 mb-3 flex-wrap-mobile align-items-center">
//               <div className="form-group w-100" id="searchOrder">
//                 <input
//                   type="text"
//                   placeholder="Lead ID"
//                   value={searchOrder}
//                   onChange={handleSearchOrder}
//                   className="form-control"
//                 />
//               </div>

//               <div className="form-group w-100" id="searchName">
//                 <input
//                   type="text"
//                   placeholder="Name"
//                   value={searchQuery}
//                   onChange={handleSearchChange}
//                   className="form-control"
//                 />
//               </div>

//               <div className="form-group w-100" id="searchLocation">
//                 <input
//                   type="text"
//                   placeholder="Customer Mobile"
//                   value={searchMobile}
//                   onChange={handleSearchChangeLocation}
//                   className="form-control"
//                 />
//               </div>

//               <div className="form-group w-100" id="searchPlotName">
//                 <input
//                   type="text"
//                   placeholder="Unit Number"
//                   value={searchPlotName}
//                   onChange={handleSearchChangesearchPlotName}
//                   className="form-control"
//                 />
//               </div>

//               <div className="w-100 ">
//                 <select
//                   className="form-select w-100 text-dark"
//                   value={statusFilter}
//                   onChange={(e) => handleStatusFilterChange(e.target.value)}
//                 >
//                   <option value="">All Status</option>
//                   {[
//                     "new",
//                     "documentPending",
//                     "paymentPending",
//                     "notInterested",
//                     "loanInprocess",
//                     "pattaInprocess",
//                     "termSheetPending",
//                     "agreementSignaturePending",
//                     "pattaApplicationFormPending",
//                     "approved",
//                     "unitisnotsold",
//                     "rejected",
//                   ].map((status) => (
//                     <option key={status} value={status}>
//                       {formatStatus(status)}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <button
//                 className="btn btn-primary"
//                 onClick={handleSearchClick}
//               >
//                 Search
//               </button>
//             </div>
//           )}

//           <div className="table-responsive">
//             <Table bordered>
//               <thead className="bg-primary text-white">
//                 <tr>
//                   <th>S.N</th>
//                   <th>Associate Name</th>
//                   <th>Associate Mobile</th>
//                   <th>Lead ID</th>
//                   <th>Project Name</th>
//                   <th>Block Name</th>
//                   <th>Unit Number</th>
//                   <th>Customer Name</th>
//                   <th>Mobile Number</th>
//                   <th>Income Source</th>
//                   <th>Lead Date</th>
//                   <th>Status</th>
//                   <th>Remark</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {leads?.length > 0 ? (
//                   leads.map((lead, i) => (
//                     <tr key={lead.id}>
//                       <td>{(currentPage - 1) * 10 + i + 1}</td>
//                       <td>{lead.creator_username}</td>
//                       <td>{lead.creator_mobile}</td>
//                       <td>{lead.order_id}</td>
//                       <td>
//                         {lead.project_name
//                           ? lead.project_name.charAt(0).toUpperCase() +
//                           lead.project_name.slice(1).toLowerCase()
//                           : ""}
//                       </td>

//                       <td>
//                         {lead.block_name
//                           ? lead.block_name.charAt(0).toUpperCase() +
//                           lead.block_name.slice(1).toLowerCase()
//                           : ""}
//                       </td>

//                       <td>
//                         {lead.plot_name
//                           ? lead.plot_name.charAt(0).toUpperCase() +
//                           lead.plot_name.slice(1).toLowerCase()
//                           : ""}
//                       </td>

//                       <td>
//                         {lead.customer_name.charAt(0).toUpperCase() +
//                           lead.customer_name.slice(1).toLowerCase()}
//                       </td>

//                       <td>{lead.mobile}</td>
//                       <td>{lead.income_source}</td>
//                       <td>{lead.date}</td>
//                       <td>
//                         <div className="w-100">
//                           <select
//                             className={`form-select custum_mnew custum_all_select ${getStatusBadgeClass(lead.status)}`}
//                             value={lead.status}
//                             // onChange={(e) => handleStatusUpdate(lead.id, e.target.value, lead.order_id)}
//                             onChange={(e) =>
//                               handleStatusUpdate(lead, e.target.value)
//                             }
//                             disabled={
//                               lead.status === "approved" ||
//                               lead.status === "notInterested" ||
//                               lead.status == "unitisnotsold"
//                             }
//                           >
//                             {[
//                               "new",
//                               "documentPending",
//                               "paymentPending",
//                               "notInterested",
//                               "loanInprocess",
//                               "pattaInprocess",
//                               "termSheetPending",
//                               "agreementSignaturePending",
//                               "pattaApplicationFormPending",
//                               "approved",
//                               "unitisnotsold",
//                               "rejected",
//                             ].map((status) => (
//                               <option
//                                 key={status}
//                                 value={status}
//                                 className={getStatusBadgeClass(status)}
//                               >
//                                 {formatStatus(status)}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                       </td>
//                       <td>
//                         <button
//                           className="btn bg-success btn-sm me-1 dark-text"
//                           onClick={() =>
//                             handleResponseLead(lead.id, lead.order_id)
//                           }
//                           title="Remark Lead"
//                           disabled={loadingResponce}
//                         >
//                           {loadingResponce ? "Loading..." : "Add Remark"}
//                         </button>
//                       </td>
//                       <td>
//                         <div className="dropdown">
//                           <button
//                             className="btn light btn-action dropdown-toggle"
//                             type="button"
//                             id={`dropdownMenuButton-${lead.id}`}
//                             data-bs-toggle="dropdown"
//                             aria-expanded="false"
//                           >
//                             <BsThreeDots size={20} />
//                           </button>
//                           <ul
//                             className="dropdown-menu"
//                             aria-labelledby={`dropdownMenuButton-${lead.id}`}
//                           >
//                             <li className="dropdown-item">
//                               <button
//                                 className="btn view_btn btn-sm me-1"
//                                 onClick={() => handleViewLead(lead.id)}
//                                 title="View Lead Details"
//                               >
//                                 <FaEye className="me-2" /> View
//                               </button>
//                             </li>
//                             <li className="dropdown-item">
//                               <button
//                                 className="btn edit_btn btn-sm me-1"
//                                 onClick={() => handleEditLead(lead.id)}
//                                 title="Edit Lead"
//                               >
//                                 <FaEdit className="me-2" /> Edit
//                               </button>
//                             </li>

//                             <li className="dropdown-item">
//                               <button
//                                 className="btn btn-danger btn-sm"
//                                 onClick={() =>
//                                   handleRemarkList(
//                                     lead.id,
//                                     lead.order_id,
//                                     userId,
//                                   )
//                                 }
//                                 title="Remark History Lead"
//                               >
//                                 <FaEdit className="me-2" /> Remark History Lead
//                               </button>
//                             </li>
//                           </ul>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="14" className="text-center">
//                       No leads found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>

//           <div className="d-flex justify-content-end">
//             <Pagination>
//               <Pagination.Prev
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//               />

//               {/* First 3 pages */}
//               {[1, 2, 3].map((pageNum) => {
//                 if (pageNum > totalPages) return null;
//                 return (
//                   <Pagination.Item
//                     key={pageNum}
//                     active={pageNum === currentPage}
//                     onClick={() => handlePageChange(pageNum)}
//                   >
//                     {pageNum}
//                   </Pagination.Item>
//                 );
//               })}

//               {/* Ellipsis if currentPage > 3 and totalPages > 4 */}
//               {currentPage > 4 && totalPages > 4 && (
//                 <Pagination.Ellipsis disabled />
//               )}

//               {/* Current page if in middle */}
//               {currentPage > 3 && currentPage < totalPages - 1 && (
//                 <Pagination.Item
//                   active
//                   onClick={() => handlePageChange(currentPage)}
//                 >
//                   {currentPage}
//                 </Pagination.Item>
//               )}

//               {/* Ellipsis before last page */}
//               {currentPage < totalPages - 2 && totalPages > 4 && (
//                 <Pagination.Ellipsis disabled />
//               )}

//               {/* Last page */}
//               {totalPages > 3 && (
//                 <Pagination.Item
//                   active={currentPage === totalPages}
//                   onClick={() => handlePageChange(totalPages)}
//                 >
//                   {totalPages}
//                 </Pagination.Item>
//               )}

//               <Pagination.Next
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               />
//             </Pagination>
//           </div>
//         </div>
//       </div>

//       {/* View Lead Modal */}
//       <Modal
//         size="lg"
//         show={showViewModal}
//         onHide={() => setShowViewModal(false)}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Property Lead Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedLead ? (
//             <Form>
//               <div className="row">
//                 <div className="col-md-12">
//                   <div className="card mb-4">
//                     <div className="card-header">
//                       <h5 className="card-title">Customer Details</h5>
//                     </div>
//                     <div className="card-body p-2">
//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Project Name:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.project_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Block Name:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.block_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>

//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Unit Number:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.plot_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Customer Name:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.customer_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>

//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Mobile Number:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.mobile}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Income Source:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.income_source}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>

//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Aadhaar Card:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.adhar_card_number}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Pan Card:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.pan_card_number}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Right Column - Document Images */}
//                 <div className="col-md-12">
//                   <div className="card">
//                     <div className="card-header">
//                       <h5 className="card-title">Document Verification</h5>
//                     </div>
//                     <div className="card-body p-2">
//                       <div className="row">
//                         {/* Aadhaar Front */}
//                         <div className="col-md-4 mb-4">
//                           <div className="document-card">
//                             <h6 className="document-title">Aadhaar Front</h6>
//                             {selectedLead.adhar_front_image ? (
//                               <img
//                                 src={`${imageAPIURL}/lead/${selectedLead.adhar_front_image}`}
//                                 alt="Aadhaar Front"
//                                 className="img-thumbnail document-image"
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src =
//                                     "https://placehold.co/300x200/cccccc/000000?text=Aadhaar+Front";
//                                 }}
//                               />
//                             ) : (
//                               <div className="document-placeholder">
//                                 <i className="bi bi-file-image fs-1 text-muted"></i>
//                                 <p className="text-muted mt-2">
//                                   No image available
//                                 </p>
//                               </div>
//                             )}

//                             <a
//                               href={`${imageAPIURL}/lead/${selectedLead.adhar_front_image}`}
//                               download={`${selectedLead.name}_PAN_${selectedLead.adhar_front_image}`}
//                               alt={`${selectedLead.name} Main`}
//                               target="_blank"
//                               className="ms-2 btn btn-primary"
//                               style={{
//                                 maxWidth: "200px",
//                                 maxHeight: "150px",
//                                 objectFit: "cover",
//                               }}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src =
//                                   "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//                               }}
//                             >
//                               Download
//                             </a>
//                           </div>
//                         </div>

//                         {/* Aadhaar Back */}
//                         <div className="col-md-4 mb-4">
//                           <div className="document-card">
//                             <h6 className="document-title">Aadhaar Back</h6>
//                             {selectedLead.adhar_back_image ? (
//                               <img
//                                 src={`${imageAPIURL}/lead/${selectedLead.adhar_back_image}`}
//                                 alt="Aadhaar Back"
//                                 className="img-thumbnail document-image"
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src =
//                                     "https://placehold.co/300x200/cccccc/000000?text=Aadhaar+Back";
//                                 }}
//                               />
//                             ) : (
//                               <div className="document-placeholder">
//                                 <i className="bi bi-file-image fs-1 text-muted"></i>
//                                 <p className="text-muted mt-2">
//                                   No image available
//                                 </p>
//                               </div>
//                             )}

//                             <a
//                               href={`${imageAPIURL}/lead/${selectedLead.adhar_back_image}`}
//                               download={`${selectedLead.name}_PAN_${selectedLead.adhar_back_image}`}
//                               alt={`${selectedLead.name} Main`}
//                               target="_blank"
//                               className="ms-2 btn btn-primary"
//                               style={{
//                                 maxWidth: "200px",
//                                 maxHeight: "150px",
//                                 objectFit: "cover",
//                               }}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src =
//                                   "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//                               }}
//                             >
//                               Download
//                             </a>
//                           </div>
//                         </div>

//                         {/* PAN Card */}
//                         <div className="col-md-4 mb-2">
//                           <div className="document-card">
//                             <h6 className="document-title">PAN Card</h6>
//                             {selectedLead.pan_card_image ? (
//                               <img
//                                 src={`${imageAPIURL}/lead/${selectedLead.pan_card_image}`}
//                                 alt="PAN Card"
//                                 className="img-thumbnail document-image"
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src =
//                                     "https://placehold.co/300x200/cccccc/000000?text=PAN+Card";
//                                 }}
//                               />
//                             ) : (
//                               <div className="document-placeholder">
//                                 <i className="bi bi-file-image fs-1 text-muted"></i>
//                                 <p className="text-muted mt-2">
//                                   No image available
//                                 </p>
//                               </div>
//                             )}
//                             <a
//                               href={`${imageAPIURL}/lead/${selectedLead.pan_card_image}`}
//                               download
//                               target="_blank"
//                               className="ms-2 btn btn-primary"
//                               style={{ maxWidth: "200px" }}
//                             >
//                               Download
//                             </a>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </Form>
//           ) : (
//             <p>Loading details...</p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="danger" onClick={() => setShowViewModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Lead Modal */}
//       <Modal
//         size="lg"
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         className="formselectnewdesign"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Property Lead</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdateSubmit}>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editProjectId">
//                   <Form.Label>Project Name</Form.Label>
//                   <Form.Select
//                     name="project_id"
//                     value={editFormData.project_id}
//                     onChange={handleEditFormChange}
//                     disabled={loadingDropdowns || projectsForEdit.length === 0}
//                     required
//                   >
//                     <option value="">Select a Project</option>
//                     {projectsForEdit.map((project) => (
//                       <option key={project.id} value={project.id}>
//                         {project.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   {loadingDropdowns && projectsForEdit.length === 0 && (
//                     <small className="text-muted">Loading projects...</small>
//                   )}
//                   {!loadingDropdowns && projectsForEdit.length === 0 && (
//                     <small className="text-danger">
//                       No projects available.
//                     </small>
//                   )}
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editBlockId">
//                   <Form.Label>Block Name</Form.Label>
//                   <Form.Select
//                     name="block_id"
//                     value={editFormData.block_id}
//                     onChange={handleEditFormChange}
//                     disabled={
//                       !editFormData.project_id ||
//                       loadingDropdowns ||
//                       blocksForEdit.length === 0
//                     }
//                     required
//                   >
//                     <option value="">Select a Block</option>
//                     {blocksForEdit.map((block) => (
//                       <option key={block.id} value={block.id}>
//                         {block.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   {editFormData.project_id &&
//                     loadingDropdowns &&
//                     blocksForEdit.length === 0 && (
//                       <small className="text-muted">Loading blocks...</small>
//                     )}
//                   {editFormData.project_id &&
//                     !loadingDropdowns &&
//                     blocksForEdit.length === 0 && (
//                       <small className="text-danger">
//                         No blocks available for this project.
//                       </small>
//                     )}
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editBlockId">
//                   <Form.Label>Unit Number</Form.Label>
//                   <Form.Select
//                     name="plot_id"
//                     value={editFormData.plot_id}
//                     onChange={handleEditFormChange}
//                     disabled={!editFormData.block_id || loadingDropdowns}
//                     required
//                   >
//                     <option value="">Select Unit</option>
//                     {plotsForEdit.map((plot) => (
//                       <option key={plot.id} value={plot.id}>
//                         {plot.plot_shop_villa_no}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   {editFormData.block_id &&
//                     loadingDropdowns &&
//                     plotsForEdit.length === 0 && (
//                       <small className="text-muted">Loading Unit...</small>
//                     )}
//                   {editFormData.block_id &&
//                     !loadingDropdowns &&
//                     plotsForEdit.length === 0 && (
//                       <small className="text-danger">
//                         No Unit available for this Block.
//                       </small>
//                     )}
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Customer Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="customer_name"
//                     value={editFormData.customer_name}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Mobile Number</Form.Label>
//                   <Form.Control
//                     type="tel"
//                     name="mobile"
//                     value={editFormData.mobile}
//                     onChange={handleEditFormChange}
//                     maxLength={10}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Income Source</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="income_source"
//                     value={editFormData.income_source}
//                     onChange={handleEditFormChange}
//                   >
//                     {incomeSourceOptions.map((option) => (
//                       <option key={option.value} value={option.value}>
//                         {option.label}
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Aadhaar Card Number</Form.Label>
//                   <Form.Control
//                     type="tel"
//                     name="adhar_card_number"
//                     value={editFormData.adhar_card_number}
//                     onChange={handleEditFormChange}
//                     maxLength={12}
//                     isInvalid={!!validationErrors.adhar_card_number}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.adhar_card_number}
//                   </Form.Control.Feedback>
//                   <Form.Text muted>Format: 123456789123 (4-4-4)</Form.Text>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Pan Card Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="pan_card_number"
//                     value={editFormData.pan_card_number}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.pan_card_number}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.pan_card_number}
//                   </Form.Control.Feedback>
//                   <Form.Text muted>
//                     Format: ABCDE1234F (5 letters, 4 digits, 1 letter)
//                   </Form.Text>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Booking Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="lead_date"
//                     value={editFormData.lead_date}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.lead_date}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.date}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Aadhaar Front</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="adharfront"
//                     onChange={handleEditFormChange}
//                   />
//                   {editFormData.adharfront && (
//                     <div className="mt-2">
//                       {typeof editFormData.adharfront === "string" ? (
//                         <>
//                           <p>Current File:</p>
//                           <img
//                             src={`${imageAPIURL}/lead/${editFormData.adharfront}`}
//                             alt="Aadhaar Front"
//                             style={{ maxWidth: "100%", maxHeight: "200px" }}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.parentNode.innerHTML = `<a href="${editFormData.adharfront}" target="_blank" rel="noopener noreferrer">View Current File</a>`;
//                             }}
//                           />
//                         </>
//                       ) : (
//                         <p>New file selected: {editFormData.adharfront.name}</p>
//                       )}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Aadhaar Back</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="adharback"
//                     onChange={handleEditFormChange}
//                   />
//                   {editFormData.adharback && (
//                     <div className="mt-2">
//                       {typeof editFormData.adharback === "string" ? (
//                         <>
//                           <p>Current File:</p>
//                           <img
//                             src={`${imageAPIURL}/lead/${editFormData.adharback}`}
//                             alt="Aadhaar Back"
//                             style={{ maxWidth: "100%", maxHeight: "200px" }}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.parentNode.innerHTML = `<a href="${editFormData.adharback}" target="_blank" rel="noopener noreferrer">View Current File</a>`;
//                             }}
//                           />
//                         </>
//                       ) : (
//                         <p>New file selected: {editFormData.adharback.name}</p>
//                       )}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Pan Card</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="pancard"
//                     onChange={handleEditFormChange}
//                   />
//                   {editFormData.pancard && (
//                     <div className="mt-2">
//                       {typeof editFormData.pancard === "string" ? (
//                         <>
//                           <p>Current File:</p>
//                           <img
//                             src={`${imageAPIURL}/lead/${editFormData.pancard}`}
//                             alt="Pan Card"
//                             style={{ maxWidth: "100%", maxHeight: "200px" }}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.parentNode.innerHTML = `<a href="${editFormData.pancard}" target="_blank" rel="noopener noreferrer">View Current File</a>`;
//                             }}
//                           />
//                         </>
//                       ) : (
//                         <p>New file selected: {editFormData.pancard.name}</p>
//                       )}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Button variant="primary" type="submit" disabled={loadingEdit}>
//               {loadingEdit ? "Updating..." : "Update Lead"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Response Lead Modal */}
//       <Modal
//         show={showResponceModal}
//         onHide={() => {
//           setShowResponceModal(false);
//           setDocumentFile([]);
//         }}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Remark</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubmitResponse}>
//             <Form.Group className="mb-3">
//               <Form.Label>Remark Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={responseText}
//                 onChange={(e) => setResponseText(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Documents</Form.Label>
//               <Form.Control
//                 type="file"
//                 accept="image/*,.pdf"
//                 onChange={(e) => setDocumentFile(Array.from(e.target.files))}
//                 multiple
//               />
//               {documentFile?.length > 0 && (
//                 <div className="mt-2">
//                   <small className="text-muted">Selected files:</small>
//                   <ul className="list-unstyled">
//                     {documentFile.map((file, index) => (
//                       <li key={index}>
//                         <small>{file.name}</small>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </Form.Group>

//             <div className="d-flex justify-content-end gap-2">
//               <Button
//                 variant="primary"
//                 type="submit"
//                 disabled={loadingResponce}
//               >
//                 {loadingResponce ? "Submitting..." : "Submit Remark"}
//               </Button>

//               <Button
//                 variant="danger"
//                 onClick={() => {
//                   setShowResponceModal(false);
//                   setDocumentFile([]);
//                 }}
//                 disabled={loadingResponce}
//               >
//                 Cancel
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Message Modal */}
//       <Modal
//         show={showMessageModal}
//         onHide={() => {
//           if (messageModalContent.type !== "confirmation") {
//             closeCustomMessageModal();
//           }
//         }}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{messageModalContent.title}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <p>{messageModalContent.text}</p>

//             {messageModalContent.showDateInput &&
//               (messageModalContent.status === "approved" ||
//                 messageModalContent.status === "unitisnotsold" ||
//                 messageModalContent.status === "rejected") && (
//                 <Form.Group className="mt-3">
//                   <Form.Label>
//                     Status Date <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={statusUpdateDate}
//                     onChange={(e) => {
//                       setStatusUpdateDate(e.target.value);
//                     }}
//                     required
//                     min="2020-01-01"
//                     max={new Date().toISOString().split("T")[0]}
//                   />
//                   <Form.Text className="text-muted">
//                     Select the date when this status change is effective.
//                   </Form.Text>
//                 </Form.Group>
//               )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           {messageModalContent.type === "confirmation" && (
//             <Button
//               variant="primary"
//               onClick={() => {
//                 if (
//                   (messageModalContent.status === "approved" ||
//                     messageModalContent.status === "unitisnotsold" ||
//                     messageModalContent.status === "rejected") &&
//                   !statusUpdateDate
//                 ) {
//                   alert("Please select a date for status change.");
//                   return;
//                 }

//                 if (messageModalContent.confirmAction) {
//                   messageModalContent.confirmAction(statusUpdateDate);
//                 }
//               }}
//             >
//               Confirm
//             </Button>
//           )}

//           <Button
//             variant="success"
//             onClick={() => {
//               closeCustomMessageModal();
//             }}
//           >
//             {messageModalContent.type === "confirmation" ? "Cancel" : "Close"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

// export default AllLeadList;

// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaDownload, FaPlus } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { FaEye, FaEdit } from "react-icons/fa";
// import { BsThreeDots } from "react-icons/bs";
// import { MdAirplanemodeInactive, MdAirplanemodeActive } from "react-icons/md";
// import { RiDeleteBin5Fill } from "react-icons/ri";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function AllLeadList() {
//   const navigate = useNavigate();
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchOrder, setSearchOrder] = useState("");
//   const [searchMobile, setSearchMobile] = useState("");
//   const [searchPlotName, setSearchPlotName] = useState("");
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showResponceModal, setShowResponceModal] = useState(false);
//   const [loadingEdit, setLoadingEdit] = useState(false);
//   const [loadingResponce, setLoadingResponce] = useState(false);
//   const [leadId, setLeadId] = useState(null);
//   const [orderId, setOrderId] = useState(null);
//   const [responseText, setResponseText] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [documentFile, setDocumentFile] = useState([]);
//   const [exporting, setExporting] = useState(false);
//   const [userId, setUserId] = useState(null);
//   const [statusUpdateDate, setStatusUpdateDate] = useState("");

//   const userType = localStorage.getItem("userType");

//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     project_id: "",
//     block_id: "",
//     plot_id: "",
//     customer_name: "",
//     mobile: "",
//     income_source: "",
//     adhar_card_number: "",
//     pan_card_number: "",
//     adharfront: null,
//     adharback: null,
//     pancard: null,
//     lead_date: "",
//   });

//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   const incomeSourceOptions = [
//     { value: "", label: "Select Income Source" },
//     { value: "business", label: "Business" },
//     { value: "salaried", label: "Salaried" },
//     { value: "rent", label: "Rent" },
//     { value: "pension", label: "Pension" },
//     { value: "other", label: "Other" },
//   ];

//   const [projectsForEdit, setProjectsForEdit] = useState([]);
//   const [blocksForEdit, setBlocksForEdit] = useState([]);
//   const [plotsForEdit, setPlotsForEdit] = useState([]);
//   const [loadingDropdowns, setLoadingDropdowns] = useState(false);
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//     showDateInput: false,
//     status: "",
//     selectedDate: "",
//   });

//   const showCustomMessageModal = (
//     title,
//     text,
//     type,
//     confirmAction = null,
//     showDateInput = false,
//     status = "",
//   ) => {
//     if (
//       showDateInput &&
//       (status === "approved" || status === "unitisnotsold")
//     ) {
//       setStatusUpdateDate(new Date().toISOString().split("T")[0]);
//     } else {
//       setStatusUpdateDate("");
//     }

//     setMessageModalContent({
//       title,
//       text,
//       type,
//       confirmAction,
//       showDateInput,
//       status,
//     });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = (keepDate = false) => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//       showDateInput: false,
//       status: "",
//       selectedDate: "",
//     });
//     if (!keepDate) {
//       setStatusUpdateDate("");
//     }
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const allowedDomains = [
//     "admin.rajasthanirealestates.in",
//     "realestateadmin.a2logicgroup.com",
//     "master.bahikhatas.com",
//   ];

//   const dontallowedDomains = ["master.bahikhatas.com"];

//   const currentDomain = window.location.host;

//   useEffect(() => {
//     const fetchProjectsListForEdit = async () => {
//       setLoadingDropdowns(true);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal(
//             "Authentication Error",
//             "Authentication token not found. Please log in.",
//             "error",
//           );
//           setLoadingDropdowns(false);
//           return;
//         }

//         const response = await fetch(`${API_URL}/project-list-block`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           showCustomMessageModal(
//             "Error",
//             errorData.message || "Failed to fetch projects for dropdown.",
//             "error",
//           );
//           setLoadingDropdowns(false);
//           return;
//         }

//         const data = await response.json();
//         setProjectsForEdit(data.data || []);
//       } catch (err) {
//         console.error("Fetch projects for edit error:", err);
//         showCustomMessageModal(
//           "Error",
//           err.message ||
//             "An unexpected error occurred while fetching projects for edit.",
//           "error",
//         );
//       } finally {
//         setLoadingDropdowns(false);
//       }
//     };

//     fetchProjectsListForEdit();
//   }, []);

//   useEffect(() => {
//     const fetchBlocksListForEdit = async () => {
//       if (editFormData.project_id) {
//         setLoadingDropdowns(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             setLoadingDropdowns(false);
//             return;
//           }

//           const response = await fetch(`${API_URL}/block-list-plot`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ project_id: editFormData.project_id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch blocks for dropdown.",
//               "error",
//             );
//             setBlocksForEdit([]);
//             setLoadingDropdowns(false);
//             return;
//           }

//           const data = await response.json();
//           setBlocksForEdit(data.data || []);
//         } catch (err) {
//           console.error("Fetch blocks for edit error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message ||
//               "An unexpected error occurred while fetching blocks for edit.",
//             "error",
//           );
//           setBlocksForEdit([]);
//         } finally {
//           setLoadingDropdowns(false);
//         }
//       } else {
//         setBlocksForEdit([]);
//         setPlotsForEdit([]);
//       }
//     };

//     fetchBlocksListForEdit();
//   }, [editFormData.project_id]);

//   useEffect(() => {
//     const fetchPlotsForEdit = async () => {
//       if (editFormData.block_id) {
//         setLoadingDropdowns(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             setLoadingDropdowns(false);
//             return;
//           }

//           const response = await fetch(`${API_URL}/property-lead-plot-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ block_id: editFormData.block_id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch units for dropdown.",
//               "error",
//             );
//             setPlotsForEdit([]);
//             setLoadingDropdowns(false);
//             return;
//           }

//           const data = await response.json();
//           setPlotsForEdit(data.data || []);
//         } catch (err) {
//           console.error("Fetch units for edit error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message ||
//               "An unexpected error occurred while fetching units for edit.",
//             "error",
//           );
//           setPlotsForEdit([]);
//         } finally {
//           setLoadingDropdowns(false);
//         }
//       } else {
//         setPlotsForEdit([]);
//       }
//     };

//     fetchPlotsForEdit();
//   }, [editFormData.block_id]);

//   const fetchLeads = async (
//     page = 1,
//     query = "",
//     orderid = "",
//     mobile = "",
//     status = "",
//     plotname = "",
//   ) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         setLoading(false);
//         return;
//       }

//       let url = `${API_URL}/property-lead-list?page=${page}&limit=10`;
//       if (mobile) url += `&mobile=${mobile}`;
//       if (query) url += `&name=${query}`;
//       if (orderid) url += `&orderid=${orderid}`;
//       if (plotname) url += `&plotname=${plotname}`;
//       if (status) url += `&status=${status}`;

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal(
//             "Authorization Error",
//             "Unauthorized: Please log in again.",
//             "error",
//           );
//         }
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch leads.");
//       }

//       const data = await response.json();

//       setLeads(data.data || []);
//       setUserId(data?.data?.length > 0 ? data.data[0].creater_id : null);
//       setTotalPages(data.totalPages || 1);
//       setCurrentPage(data.currentPage || page);
//     } catch (err) {
//       console.error("Fetch leads error:", err);
//       setError(err.message);
//       if (!showMessageModal) {
//         showCustomMessageModal(
//           "Error",
//           err.message || "An unexpected error occurred while fetching leads.",
//           "error",
//         );
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeads(currentPage);
//   }, [currentPage]);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleSearchOrder = (e) => {
//     setSearchOrder(e.target.value);
//   };

//   const handleSearchChangeLocation = (e) => {
//     setSearchMobile(e.target.value);
//   };

//   const handleSearchChangesearchPlotName = (e) => {
//     setSearchPlotName(e.target.value);
//   };

//   const handleSearchClick = () => {
//     setCurrentPage(1);
//     fetchLeads(
//       1,
//       searchQuery.trim(),
//       searchOrder,
//       searchMobile.trim(),
//       statusFilter,
//       searchPlotName.trim(),
//     );
//   };

//   const handleClearSearch = () => {
//     setSearchQuery("");
//     setSearchOrder("");
//     setSearchMobile("");
//     setSearchPlotName("");
//     setStatusFilter("");
//     setCurrentPage(1);
//     fetchLeads(1, "", "", "", "", "");
//   };

//   const handleStatusFilterChange = (status) => {
//     setStatusFilter(status);
//     setCurrentPage(1);
//     fetchLeads(
//       1,
//       searchQuery.trim(),
//       searchOrder,
//       searchMobile.trim(),
//       status,
//       searchPlotName.trim(),
//     );
//   };

//   const handleViewLead = async (id) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/property-lead-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch lead details.",
//           "error",
//         );
//         setLoading(false);
//         return;
//       }

//       const data = await response.json();
//       setSelectedLead(data.data);
//       setShowViewModal(true);
//     } catch (err) {
//       showCustomMessageModal(
//         "Error",
//         "An error occurred while fetching lead details.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditLead = async (id) => {
//     setLoadingEdit(true);
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/property-lead-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch lead details for edit.",
//           "error",
//         );
//         setLoadingEdit(false);
//         return;
//       }

//       const data = await response.json();
//       const leadData = data.data;

//       let formattedDate = "";
//       if (leadData.date) {
//         const [day, month, year] = leadData.date.split("-");
//         formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
//       }

//       setEditFormData({
//         id: leadData.id,
//         project_id: leadData.project_id,
//         block_id: leadData.block_id,
//         plot_id: leadData.plot_id,
//         customer_name: leadData.customer_name,
//         mobile: leadData.mobile,
//         income_source: leadData.income_source,
//         adhar_card_number: leadData.adhar_card_number,
//         pan_card_number: leadData.pan_card_number,
//         adharfront: leadData.adhar_front_image || null,
//         adharback: leadData.adhar_back_image || null,
//         pancard: leadData.pan_card_image || null,
//         lead_date: formattedDate,
//       });

//       setShowEditModal(true);
//     } catch (err) {
//       showCustomMessageModal(
//         "Error",
//         "An unexpected error occurred while fetching lead details for edit.",
//         "error",
//       );
//     } finally {
//       setLoadingEdit(false);
//     }
//   };

//   const handleResponseLead = async (id, orderid) => {
//     setLoadingResponce(true);
//     try {
//       setLeadId(id);
//       setOrderId(orderid);
//       setShowResponceModal(true);
//     } catch (err) {
//       showCustomMessageModal(
//         "Error",
//         "An unexpected error occurred while fetching lead details for edit.",
//         "error",
//       );
//     } finally {
//       setLoadingResponce(false);
//     }
//   };

//   const handleSubmitResponse = async (e) => {
//     e.preventDefault();
//     setLoadingResponce(true);
//     try {
//       const token = getAuthToken();
//       const formData = new FormData();
//       formData.append("lead_id", leadId);
//       formData.append("response", responseText);

//       documentFile.forEach((file) => {
//         formData.append("document", file);
//       });

//       const response = await fetch(`${API_URL}/property-lead-response-store`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       const data = await response.json();
//       if (response.ok) {
//         showCustomMessageModal(
//           "Success",
//           "Response submitted successfully",
//           "success",
//         );
//         setShowResponceModal(false);
//         setResponseText("");
//         setDocumentFile([]);
//       } else {
//         throw new Error(data.message || "Failed to submit response");
//       }

//       if (socket && socket.readyState === WebSocket.OPEN) {
//         const notificationPayload = {
//           user_id: userId,
//           type: "property_lead",
//           message: `A response has been added for Property Lead ${leadId}.`,
//           statusremark: null,
//           remark: responseText,
//           order_id: orderId,
//           action_by: "admin",
//           date: new Date().toISOString(),
//         };
//         socket.send(JSON.stringify(notificationPayload));
//         console.warn("notificationPayload", notificationPayload);
//       }
//     } catch (err) {
//       showCustomMessageModal("Error", err.message, "error");
//     } finally {
//       setLoadingResponce(false);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files && files.length > 0) {
//       setEditFormData((prevData) => ({ ...prevData, [name]: files[0] }));
//     } else {
//       setEditFormData((prevData) => ({ ...prevData, [name]: value }));
//     }
//   };

//   const [validationErrors, setValidationErrors] = useState({
//     project_id: "",
//     block_id: "",
//     plot_id: "",
//     customer_name: "",
//     mobile: "",
//     adhar_card_number: "",
//     pan_card_number: "",
//     adharfront: "",
//     adharback: "",
//     pancard: "",
//     lead_date: "",
//   });

//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;

//     if (!editFormData.project_id) {
//       errors.project_id = "Project is required";
//       isValid = false;
//     }

//     if (!editFormData.block_id) {
//       errors.block_id = "Block is required";
//       isValid = false;
//     }

//     if (!editFormData.plot_id) {
//       errors.plot_id = "Unit is required";
//       isValid = false;
//     }

//     if (
//       !editFormData.customer_name ||
//       editFormData.customer_name.trim() === ""
//     ) {
//       errors.customer_name = "Customer name is required";
//       isValid = false;
//     }

//     if (!editFormData.mobile) {
//       errors.mobile = "Mobile number is required";
//       isValid = false;
//     } else if (!/^\d{10}$/.test(editFormData.mobile)) {
//       errors.mobile = "Mobile number must be 10 digits";
//       isValid = false;
//     }

//     if (!editFormData.adhar_card_number) {
//       errors.adhar_card_number = "Aadhaar number is required";
//       isValid = false;
//     } else if (!/^\d{12}$/.test(editFormData.adhar_card_number)) {
//       errors.adhar_card_number = "Aadhaar must be 12 digits";
//       isValid = false;
//     }

//     if (!editFormData.pan_card_number) {
//       errors.pan_card_number = "PAN number is required";
//       isValid = false;
//     } else if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(editFormData.pan_card_number)) {
//       errors.pan_card_number = "Invalid PAN format (e.g., ABCDE1234F)";
//       isValid = false;
//     }

//     if (
//       editFormData.adharfront &&
//       typeof editFormData.adharfront !== "string"
//     ) {
//       if (editFormData.adharfront.size > 2 * 1024 * 1024) {
//         errors.adharfront = "File size must be less than 2MB";
//         isValid = false;
//       }
//       if (
//         !["image/jpeg", "image/png", "application/pdf"].includes(
//           editFormData.adharfront.type,
//         )
//       ) {
//         errors.adharfront = "Only JPEG, PNG, or PDF files are allowed";
//         isValid = false;
//       }
//     }
//     setValidationErrors(errors);
//     return isValid;
//   };

//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) {
//       return;
//     }
//     setLoadingEdit(true);
//     try {
//       const token = getAuthToken();
//       const formData = new FormData();

//       for (const key in editFormData) {
//         if (editFormData[key] !== null) {
//           if (typeof editFormData[key] !== "string") {
//             formData.append(key, editFormData[key]);
//           } else if (
//             key !== "adharfront" &&
//             key !== "adharback" &&
//             key !== "pancard"
//           ) {
//             formData.append(key, editFormData[key]);
//           }
//         }
//       }

//       const selectedProject = projectsForEdit.find(
//         (p) => p.id === parseInt(editFormData.project_id),
//       );
//       if (selectedProject)
//         formData.append("project_name", selectedProject.name);

//       const selectedBlock = blocksForEdit.find(
//         (b) => b.id === parseInt(editFormData.block_id),
//       );
//       if (selectedBlock) formData.append("block_name", selectedBlock.name);

//       const selectedPlot = plotsForEdit.find(
//         (p) => p.id === parseInt(editFormData.plot_id),
//       );
//       if (selectedPlot)
//         formData.append("plot_name", selectedPlot.plot_shop_villa_no);

//       const response = await fetch(`${API_URL}/property-lead-update`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update lead.");
//       }

//       const result = await response.json();

//       if (result.success == "1") {
//         showCustomMessageModal(
//           "Success",
//           result.message || "Lead updated successfully.",
//           "success",
//         );
//         setShowEditModal(false);
//         fetchLeads(currentPage, searchQuery);
//       } else {
//         showCustomMessageModal("Error", result.message, "error");
//       }
//     } catch (err) {
//       showCustomMessageModal("Error", err.message, "error");
//     } finally {
//       setLoadingEdit(false);
//     }
//   };

//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     const ws = new WebSocket(process.env.REACT_APP_WS_URL);

//     ws.onopen = () => {
//       console.log("WebSocket connection established");
//     };

//     ws.onmessage = (event) => {
//       try {
//         const data = JSON.parse(event.data);
//         console.log("Message from server:", data);
//       } catch (e) {
//         console.log("Raw message:", event.data);
//       }
//     };

//     ws.onclose = () => {
//       console.log("WebSocket disconnected");
//     };

//     ws.onerror = (err) => {
//       console.error("WebSocket error:", err);
//     };

//     setSocket(ws);

//     return () => ws.close();
//   }, []);

//   const bookProperty = async (projectId, blockId, plotId, userId) => {
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/book-now`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           project_id: projectId,
//           block_id: blockId,
//           plot_id: plotId,
//           user_id: userId,
//         }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to book the property.");
//       }
//       const result = await response.json();
//       showCustomMessageModal(
//         "Success",
//         result.message || "Property booked successfully.",
//         "success",
//       );
//     } catch (err) {
//       console.error("Book property error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "An error occurred while booking the property.",
//         "error",
//       );
//     }
//   };

//   const handleStatusUpdate = (lead, newStatus) => {
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Are you sure you want to change the status to ${formatStatus(newStatus)} on ${lead.date} Lead Date?`,
//       "confirmation",
//       async (selectedDate) => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const payload = {
//             id: lead.id,
//             status: newStatus,
//           };
//           if (
//             (newStatus === "approved" || newStatus === "unitisnotsold") &&
//             selectedDate
//           ) {
//             payload.status_date = selectedDate;
//           }

//           console.log("Sending payload:", payload);

//           const response = await fetch(
//             `${API_URL}/property-lead-update-status`,
//             {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//               },
//               body: JSON.stringify(payload),
//             },
//           );

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(
//               errorData.message || "Failed to update lead status.",
//             );
//           }

//           const result = await response.json();

//           closeCustomMessageModal();
//           showCustomMessageModal(
//             "Success",
//             result.message || "Lead status updated successfully.",
//             "success",
//           );
//           fetchLeads(currentPage, searchQuery);

//           if (newStatus === "approved") {
//             await bookProperty(
//               lead.project_id,
//               lead.block_id,
//               lead.plot_id,
//               lead.creater_id,
//             );
//           }

//           if (socket && socket.readyState === WebSocket.OPEN) {
//             const notificationPayload = {
//               user_id: userId,
//               type: "loan_lead",
//               message: `Loan lead ${lead.order_id} status changed to ${newStatus}.`,
//               statusremark: newStatus,
//               remark: null,
//               order_id: lead.order_id,
//               action_by: "admin",
//               date: new Date().toISOString(),
//               status_date:
//                 newStatus === "approved" || newStatus === "unitisnotsold"
//                   ? selectedDate
//                   : null,
//             };
//             socket.send(JSON.stringify(notificationPayload));
//           }
//         } catch (err) {
//           closeCustomMessageModal();
//           showCustomMessageModal(
//             "Error",
//             err.message || "An error occurred while updating status.",
//             "error",
//           );
//         } finally {
//           setLoading(false);
//         }
//       },
//       newStatus === "approved" || newStatus === "unitisnotsold",
//       newStatus,
//     );
//   };

//   const handleDeleteLead = (id) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this lead? This action cannot be undone.",
//       "confirmation",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const response = await fetch(`${API_URL}/property-lead-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete lead.");
//           }

//           const result = await response.json();
//           showCustomMessageModal(
//             "Success",
//             result.message || "Lead deleted successfully.",
//             "success",
//           );
//           fetchLeads(currentPage, searchQuery);
//         } catch (err) {
//           showCustomMessageModal(
//             "Error",
//             err.message || "An error occurred while deleting lead.",
//             "error",
//           );
//         } finally {
//           setLoading(false);
//           closeCustomMessageModal();
//         }
//       },
//     );
//   };

//   const handleRemarkList = (leadId, orderid, userId) => {
//     navigate(`/lead-remarks/${leadId}/${orderid}/${userId}`);
//   };

//   const getStatusBadgeClass = (status) => {
//     const classes = {
//       pending: "bg-warning text-white",
//       inprocess: "bg-info text-white",
//       approved: "bg-success text-white",
//       available: "bg-success text-dark",
//       sold: "bg-danger",
//       new: "bg-warning text-white",
//       unitisnotsold: "bg-danger",
//     };
//     return classes[status] || "bg-secondary";
//   };

//   const formatStatus = (status) => {
//     const statusMap = {
//       new: "New",
//       documentPending: "Document Pending",
//       paymentPending: "Payment Pending",
//       notInterested: "Not Interested",
//       loanInprocess: "Loan In Process",
//       pattaInprocess: "Patta In Process",
//       termSheetPending: "Term Sheet Pending",
//       agreementSignaturePending: "Agreement Signature Pending",
//       pattaApplicationFormPending: "Patta Application Form Pending",
//       approved: "Approved",
//       unitisnotsold: "Unit is not sold",
//       rejected: "Rejected",
//     };
//     return statusMap[status] || status;
//   };

//   const exportAllToExcel = async () => {
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         alert("Please login!");
//         return;
//       }

//       let url = `${API_URL}/lead-properties-new-exceldownload`;

//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "text/csv",
//         },
//       });

//       if (!response.ok) {
//         alert("Server Error: Unable to download!");
//         return;
//       }

//       const csvData = await response.text();

//       const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.setAttribute("download", `projects_${Date.now()}.csv`);
//       link.click();
//     } catch (error) {
//       console.error("CSV Export Error:", error);
//       alert("Export Failed! Try again");
//     }
//   };

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1800px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               📋
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 All Property Lead
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage and track all property leads
//               </p>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 flexWrap: "wrap",
//                 alignItems: "center",
//               }}
//             >
//               <button
//                 onClick={exportAllToExcel}
//                 disabled={exporting}
//                 style={{
//                   padding: "10px 16px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #16a34a, #22c55e)",
//                   color: "#ffffff",
//                   fontWeight: "700",
//                   fontSize: "13px",
//                   cursor: exporting ? "not-allowed" : "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "6px",
//                   boxShadow: "0 4px 12px rgba(22, 163, 74, 0.25)",
//                 }}
//               >
//                 <FaDownload />
//                 {exporting ? "Exporting..." : "Export"}
//               </button>

//               <Link
//                 to="/create-lead"
//                 style={{
//                   padding: "10px 16px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontWeight: "700",
//                   fontSize: "13px",
//                   textDecoration: "none",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "6px",
//                   boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
//                 }}
//               >
//                 <FaPlus /> Add Lead
//               </Link>

//               <Link
//                 to="/create-lead-by-uploading-csv"
//                 style={{
//                   padding: "10px 16px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontWeight: "700",
//                   fontSize: "13px",
//                   textDecoration: "none",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "6px",
//                   boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
//                 }}
//               >
//                 <FaPlus /> Upload CSV
//               </Link>

//               <button
//                 onClick={handleToggle}
//                 style={{
//                   padding: "12px 16px",
//                   borderRadius: "12px",
//                   border: "1.5px solid #e2e8f0",
//                   background: isFilterActive ? "#1e5799" : "#ffffff",
//                   color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                   fontSize: "16px",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//                 title="Toggle Filters"
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "24px" }}>
//               {/* 🎯 FILTERS */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "12px",
//                     marginBottom: "20px",
//                     flexWrap: "wrap",
//                     alignItems: "flex-end",
//                   }}
//                 >
//                   <div style={{ flex: 1, minWidth: "150px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         fontSize: "12.5px",
//                         fontWeight: "700",
//                         color: "#1e3a5f",
//                         marginBottom: "6px",
//                       }}
//                     >
//                       Lead ID
//                     </label>
//                     <input
//                       type="text"
//                       placeholder="Lead ID"
//                       value={searchOrder}
//                       onChange={handleSearchOrder}
//                       style={{
//                         width: "100%",
//                         padding: "10px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         outline: "none",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </div>

//                   <div style={{ flex: 1, minWidth: "150px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         fontSize: "12.5px",
//                         fontWeight: "700",
//                         color: "#1e3a5f",
//                         marginBottom: "6px",
//                       }}
//                     >
//                       Name
//                     </label>
//                     <input
//                       type="text"
//                       placeholder="Name"
//                       value={searchQuery}
//                       onChange={handleSearchChange}
//                       style={{
//                         width: "100%",
//                         padding: "10px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         outline: "none",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </div>

//                   <div style={{ flex: 1, minWidth: "150px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         fontSize: "12.5px",
//                         fontWeight: "700",
//                         color: "#1e3a5f",
//                         marginBottom: "6px",
//                       }}
//                     >
//                       Customer Mobile
//                     </label>
//                     <input
//                       type="text"
//                       placeholder="Customer Mobile"
//                       value={searchMobile}
//                       onChange={handleSearchChangeLocation}
//                       style={{
//                         width: "100%",
//                         padding: "10px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         outline: "none",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </div>

//                   <div style={{ flex: 1, minWidth: "150px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         fontSize: "12.5px",
//                         fontWeight: "700",
//                         color: "#1e3a5f",
//                         marginBottom: "6px",
//                       }}
//                     >
//                       Unit Number
//                     </label>
//                     <input
//                       type="text"
//                       placeholder="Unit Number"
//                       value={searchPlotName}
//                       onChange={handleSearchChangesearchPlotName}
//                       style={{
//                         width: "100%",
//                         padding: "10px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         outline: "none",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </div>

//                   <div style={{ flex: 1, minWidth: "160px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         fontSize: "12.5px",
//                         fontWeight: "700",
//                         color: "#1e3a5f",
//                         marginBottom: "6px",
//                       }}
//                     >
//                       Status
//                     </label>
//                     <select
//                       value={statusFilter}
//                       onChange={(e) => handleStatusFilterChange(e.target.value)}
//                       style={{
//                         width: "100%",
//                         padding: "10px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         outline: "none",
//                         fontSize: "14px",
//                         background: "#fff",
//                       }}
//                     >
//                       <option value="">All Status</option>
//                       {[
//                         "new",
//                         "documentPending",
//                         "paymentPending",
//                         "notInterested",
//                         "loanInprocess",
//                         "pattaInprocess",
//                         "termSheetPending",
//                         "agreementSignaturePending",
//                         "pattaApplicationFormPending",
//                         "approved",
//                         "unitisnotsold",
//                         "rejected",
//                       ].map((status) => (
//                         <option key={status} value={status}>
//                           {formatStatus(status)}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <button
//                     type="button"
//                     onClick={handleSearchClick}
//                     style={{
//                       padding: "10px 22px",
//                       borderRadius: "10px",
//                       border: "none",
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                       fontWeight: "700",
//                       cursor: "pointer",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Search
//                   </button>

//                   <button
//                     type="button"
//                     onClick={handleClearSearch}
//                     style={{
//                       padding: "10px 18px",
//                       borderRadius: "10px",
//                       border: "1.5px solid #e2e8f0",
//                       background: "#ffffff",
//                       color: "#1e3a5f",
//                       fontWeight: "700",
//                       cursor: "pointer",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Clear
//                   </button>
//                 </div>
//               )}

//               {loading ? (
//                 <div
//                   style={{
//                     textAlign: "center",
//                     padding: "60px 20px",
//                     color: "#64748b",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: "40px",
//                       height: "40px",
//                       border: "3px solid #cbd5e1",
//                       borderTop: "3px solid #2b6cb0",
//                       borderRadius: "50%",
//                       display: "inline-block",
//                       animation: "spin 0.8s linear infinite",
//                     }}
//                   />
//                   <p
//                     style={{
//                       marginTop: "16px",
//                       fontSize: "14px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     Loading Property Leads...
//                   </p>
//                 </div>
//               ) : error ? (
//                 <div
//                   style={{
//                     background: "#fef2f2",
//                     border: "1.5px solid #fecaca",
//                     color: "#991b1b",
//                     borderRadius: "12px",
//                     padding: "14px 18px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     gap: "12px",
//                   }}
//                 >
//                   <span>{error}</span>
//                   <button
//                     onClick={() => fetchLeads()}
//                     style={{
//                       padding: "6px 14px",
//                       borderRadius: "8px",
//                       border: "none",
//                       background: "#dc2626",
//                       color: "#ffffff",
//                       fontWeight: "700",
//                       fontSize: "13px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Retry
//                   </button>
//                 </div>
//               ) : (
//                 <>
//                   <div className="table-responsive">
//                     <Table bordered hover style={{ minWidth: "1400px" }}>
//                       <thead
//                         style={{
//                           background:
//                             "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                           color: "#ffffff",
//                         }}
//                       >
//                         <tr>
//                           <th>S.N</th>
//                           <th>Associate Name</th>
//                           <th>Associate Mobile</th>
//                           <th>Lead ID</th>
//                           <th>Project Name</th>
//                           <th>Block Name</th>
//                           <th>Unit Number</th>
//                           <th>Customer Name</th>
//                           <th>Mobile Number</th>
//                           <th>Income Source</th>
//                           <th>Lead Date</th>
//                           <th>Status</th>
//                           <th>Remark</th>
//                           <th>Actions</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {leads?.length > 0 ? (
//                           leads.map((lead, i) => (
//                             <tr key={lead.id}>
//                               <td>{(currentPage - 1) * 10 + i + 1}</td>
//                               <td>{lead.creator_username}</td>
//                               <td>{lead.creator_mobile}</td>
//                               <td>{lead.order_id}</td>
//                               <td>
//                                 {lead.project_name
//                                   ? lead.project_name.charAt(0).toUpperCase() +
//                                     lead.project_name.slice(1).toLowerCase()
//                                   : ""}
//                               </td>
//                               <td>
//                                 {lead.block_name
//                                   ? lead.block_name.charAt(0).toUpperCase() +
//                                     lead.block_name.slice(1).toLowerCase()
//                                   : ""}
//                               </td>
//                               <td>
//                                 {lead.plot_name
//                                   ? lead.plot_name.charAt(0).toUpperCase() +
//                                     lead.plot_name.slice(1).toLowerCase()
//                                   : ""}
//                               </td>
//                               <td>
//                                 {lead.customer_name
//                                   ? lead.customer_name.charAt(0).toUpperCase() +
//                                     lead.customer_name.slice(1).toLowerCase()
//                                   : ""}
//                               </td>
//                               <td>{lead.mobile}</td>
//                               <td>{lead.income_source}</td>
//                               <td>{lead.date}</td>
//                               <td>
//                                 <div className="w-100">
//                                   <select
//                                     className={`form-select custum_mnew custum_all_select ${getStatusBadgeClass(
//                                       lead.status,
//                                     )}`}
//                                     value={lead.status}
//                                     onChange={(e) =>
//                                       handleStatusUpdate(lead, e.target.value)
//                                     }
//                                     disabled={
//                                       lead.status === "approved" ||
//                                       lead.status === "notInterested" ||
//                                       lead.status == "unitisnotsold"
//                                     }
//                                     style={{ minWidth: "140px" }}
//                                   >
//                                     {[
//                                       "new",
//                                       "documentPending",
//                                       "paymentPending",
//                                       "notInterested",
//                                       "loanInprocess",
//                                       "pattaInprocess",
//                                       "termSheetPending",
//                                       "agreementSignaturePending",
//                                       "pattaApplicationFormPending",
//                                       "approved",
//                                       "unitisnotsold",
//                                       "rejected",
//                                     ].map((status) => (
//                                       <option
//                                         key={status}
//                                         value={status}
//                                         className={getStatusBadgeClass(status)}
//                                       >
//                                         {formatStatus(status)}
//                                       </option>
//                                     ))}
//                                   </select>
//                                 </div>
//                               </td>
//                               <td>
//                                 <button
//                                   className="btn bg-success btn-sm me-1 dark-text"
//                                   onClick={() =>
//                                     handleResponseLead(lead.id, lead.order_id)
//                                   }
//                                   title="Remark Lead"
//                                   disabled={loadingResponce}
//                                   style={{ borderRadius: "8px", fontWeight: 600 }}
//                                 >
//                                   {loadingResponce ? "Loading..." : "Add Remark"}
//                                 </button>
//                               </td>
//                               <td>
//                                 <div className="dropdown">
//                                   <button
//                                     className="btn light btn-action dropdown-toggle"
//                                     type="button"
//                                     id={`dropdownMenuButton-${lead.id}`}
//                                     data-bs-toggle="dropdown"
//                                     aria-expanded="false"
//                                   >
//                                     <BsThreeDots size={20} />
//                                   </button>
//                                   <ul
//                                     className="dropdown-menu"
//                                     aria-labelledby={`dropdownMenuButton-${lead.id}`}
//                                   >
//                                     <li className="dropdown-item">
//                                       <button
//                                         className="btn view_btn btn-sm me-1"
//                                         onClick={() => handleViewLead(lead.id)}
//                                         title="View Lead Details"
//                                       >
//                                         <FaEye className="me-2" /> View
//                                       </button>
//                                     </li>
//                                     <li className="dropdown-item">
//                                       <button
//                                         className="btn edit_btn btn-sm me-1"
//                                         onClick={() => handleEditLead(lead.id)}
//                                         title="Edit Lead"
//                                       >
//                                         <FaEdit className="me-2" /> Edit
//                                       </button>
//                                     </li>
//                                     <li className="dropdown-item">
//                                       <button
//                                         className="btn btn-danger btn-sm"
//                                         onClick={() =>
//                                           handleRemarkList(
//                                             lead.id,
//                                             lead.order_id,
//                                             userId,
//                                           )
//                                         }
//                                         title="Remark History Lead"
//                                       >
//                                         <FaEdit className="me-2" /> Remark History
//                                       </button>
//                                     </li>
//                                   </ul>
//                                 </div>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td
//                               colSpan="14"
//                               className="text-center py-4"
//                               style={{
//                                 color: "#dc2626",
//                                 fontWeight: "700",
//                               }}
//                             >
//                               No leads found.
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {leads?.length > 0 && (
//                     <div className="d-flex justify-content-end mt-3">
//                       <Pagination>
//                         <Pagination.Prev
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           disabled={currentPage === 1}
//                         />

//                         {[1, 2, 3].map((pageNum) => {
//                           if (pageNum > totalPages) return null;
//                           return (
//                             <Pagination.Item
//                               key={pageNum}
//                               active={pageNum === currentPage}
//                               onClick={() => handlePageChange(pageNum)}
//                             >
//                               {pageNum}
//                             </Pagination.Item>
//                           );
//                         })}

//                         {currentPage > 4 && totalPages > 4 && (
//                           <Pagination.Ellipsis disabled />
//                         )}

//                         {currentPage > 3 && currentPage < totalPages - 1 && (
//                           <Pagination.Item
//                             active
//                             onClick={() => handlePageChange(currentPage)}
//                           >
//                             {currentPage}
//                           </Pagination.Item>
//                         )}

//                         {currentPage < totalPages - 2 && totalPages > 4 && (
//                           <Pagination.Ellipsis disabled />
//                         )}

//                         {totalPages > 3 && (
//                           <Pagination.Item
//                             active={currentPage === totalPages}
//                             onClick={() => handlePageChange(totalPages)}
//                           >
//                             {totalPages}
//                           </Pagination.Item>
//                         )}

//                         <Pagination.Next
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                         />
//                       </Pagination>
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* ===================== MODALS (UNCHANGED) ===================== */}

//       {/* View Lead Modal */}
//       <Modal
//         size="lg"
//         show={showViewModal}
//         onHide={() => setShowViewModal(false)}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Property Lead Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedLead ? (
//             <Form>
//               <div className="row">
//                 <div className="col-md-12">
//                   <div className="card mb-4">
//                     <div className="card-header">
//                       <h5 className="card-title">Customer Details</h5>
//                     </div>
//                     <div className="card-body p-2">
//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Project Name:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.project_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Block Name:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.block_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>

//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Unit Number:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.plot_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Customer Name:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.customer_name}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>

//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Mobile Number:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.mobile}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Income Source:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.income_source}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>

//                       <Form.Group as={Row}>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Aadhaar Card:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.adhar_card_number}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                         <Form.Label column sm="3" xs="6" className="text-muted">
//                           Pan Card:
//                         </Form.Label>
//                         <Col sm="3" xs="6">
//                           <Form.Control
//                             plaintext
//                             readOnly
//                             defaultValue={selectedLead.pan_card_number}
//                             className="fw-semibold"
//                           />
//                         </Col>
//                       </Form.Group>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-md-12">
//                   <div className="card">
//                     <div className="card-header">
//                       <h5 className="card-title">Document Verification</h5>
//                     </div>
//                     <div className="card-body p-2">
//                       <div className="row">
//                         <div className="col-md-4 mb-4">
//                           <div className="document-card">
//                             <h6 className="document-title">Aadhaar Front</h6>
//                             {selectedLead.adhar_front_image ? (
//                               <img
//                                 src={`${imageAPIURL}/lead/${selectedLead.adhar_front_image}`}
//                                 alt="Aadhaar Front"
//                                 className="img-thumbnail document-image"
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src =
//                                     "https://placehold.co/300x200/cccccc/000000?text=Aadhaar+Front";
//                                 }}
//                               />
//                             ) : (
//                               <div className="document-placeholder">
//                                 <i className="bi bi-file-image fs-1 text-muted"></i>
//                                 <p className="text-muted mt-2">
//                                   No image available
//                                 </p>
//                               </div>
//                             )}
//                             <a
//                               href={`${imageAPIURL}/lead/${selectedLead.adhar_front_image}`}
//                               download
//                               target="_blank"
//                               className="ms-2 btn btn-primary"
//                               rel="noreferrer"
//                             >
//                               Download
//                             </a>
//                           </div>
//                         </div>

//                         <div className="col-md-4 mb-4">
//                           <div className="document-card">
//                             <h6 className="document-title">Aadhaar Back</h6>
//                             {selectedLead.adhar_back_image ? (
//                               <img
//                                 src={`${imageAPIURL}/lead/${selectedLead.adhar_back_image}`}
//                                 alt="Aadhaar Back"
//                                 className="img-thumbnail document-image"
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src =
//                                     "https://placehold.co/300x200/cccccc/000000?text=Aadhaar+Back";
//                                 }}
//                               />
//                             ) : (
//                               <div className="document-placeholder">
//                                 <i className="bi bi-file-image fs-1 text-muted"></i>
//                                 <p className="text-muted mt-2">
//                                   No image available
//                                 </p>
//                               </div>
//                             )}
//                             <a
//                               href={`${imageAPIURL}/lead/${selectedLead.adhar_back_image}`}
//                               download
//                               target="_blank"
//                               className="ms-2 btn btn-primary"
//                               rel="noreferrer"
//                             >
//                               Download
//                             </a>
//                           </div>
//                         </div>

//                         <div className="col-md-4 mb-2">
//                           <div className="document-card">
//                             <h6 className="document-title">PAN Card</h6>
//                             {selectedLead.pan_card_image ? (
//                               <img
//                                 src={`${imageAPIURL}/lead/${selectedLead.pan_card_image}`}
//                                 alt="PAN Card"
//                                 className="img-thumbnail document-image"
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src =
//                                     "https://placehold.co/300x200/cccccc/000000?text=PAN+Card";
//                                 }}
//                               />
//                             ) : (
//                               <div className="document-placeholder">
//                                 <i className="bi bi-file-image fs-1 text-muted"></i>
//                                 <p className="text-muted mt-2">
//                                   No image available
//                                 </p>
//                               </div>
//                             )}
//                             <a
//                               href={`${imageAPIURL}/lead/${selectedLead.pan_card_image}`}
//                               download
//                               target="_blank"
//                               className="ms-2 btn btn-primary"
//                               rel="noreferrer"
//                             >
//                               Download
//                             </a>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </Form>
//           ) : (
//             <p>Loading details...</p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="danger" onClick={() => setShowViewModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Lead Modal */}
//       <Modal
//         size="lg"
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         className="formselectnewdesign"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Property Lead</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdateSubmit}>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editProjectId">
//                   <Form.Label>Project Name</Form.Label>
//                   <Form.Select
//                     name="project_id"
//                     value={editFormData.project_id}
//                     onChange={handleEditFormChange}
//                     disabled={loadingDropdowns || projectsForEdit.length === 0}
//                     required
//                   >
//                     <option value="">Select a Project</option>
//                     {projectsForEdit.map((project) => (
//                       <option key={project.id} value={project.id}>
//                         {project.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editBlockId">
//                   <Form.Label>Block Name</Form.Label>
//                   <Form.Select
//                     name="block_id"
//                     value={editFormData.block_id}
//                     onChange={handleEditFormChange}
//                     disabled={
//                       !editFormData.project_id ||
//                       loadingDropdowns ||
//                       blocksForEdit.length === 0
//                     }
//                     required
//                   >
//                     <option value="">Select a Block</option>
//                     {blocksForEdit.map((block) => (
//                       <option key={block.id} value={block.id}>
//                         {block.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Unit Number</Form.Label>
//                   <Form.Select
//                     name="plot_id"
//                     value={editFormData.plot_id}
//                     onChange={handleEditFormChange}
//                     disabled={!editFormData.block_id || loadingDropdowns}
//                     required
//                   >
//                     <option value="">Select Unit</option>
//                     {plotsForEdit.map((plot) => (
//                       <option key={plot.id} value={plot.id}>
//                         {plot.plot_shop_villa_no}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Customer Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="customer_name"
//                     value={editFormData.customer_name}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Mobile Number</Form.Label>
//                   <Form.Control
//                     type="tel"
//                     name="mobile"
//                     value={editFormData.mobile}
//                     onChange={handleEditFormChange}
//                     maxLength={10}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Income Source</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="income_source"
//                     value={editFormData.income_source}
//                     onChange={handleEditFormChange}
//                   >
//                     {incomeSourceOptions.map((option) => (
//                       <option key={option.value} value={option.value}>
//                         {option.label}
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Aadhaar Card Number</Form.Label>
//                   <Form.Control
//                     type="tel"
//                     name="adhar_card_number"
//                     value={editFormData.adhar_card_number}
//                     onChange={handleEditFormChange}
//                     maxLength={12}
//                     isInvalid={!!validationErrors.adhar_card_number}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.adhar_card_number}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Pan Card Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="pan_card_number"
//                     value={editFormData.pan_card_number}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.pan_card_number}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.pan_card_number}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Booking Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="lead_date"
//                     value={editFormData.lead_date}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Aadhaar Front</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="adharfront"
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Aadhaar Back</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="adharback"
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Pan Card</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="pancard"
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Button variant="primary" type="submit" disabled={loadingEdit}>
//               {loadingEdit ? "Updating..." : "Update Lead"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Response Lead Modal */}
//       <Modal
//         show={showResponceModal}
//         onHide={() => {
//           setShowResponceModal(false);
//           setDocumentFile([]);
//         }}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Remark</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubmitResponse}>
//             <Form.Group className="mb-3">
//               <Form.Label>Remark Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={responseText}
//                 onChange={(e) => setResponseText(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Documents</Form.Label>
//               <Form.Control
//                 type="file"
//                 accept="image/*,.pdf"
//                 onChange={(e) => setDocumentFile(Array.from(e.target.files))}
//                 multiple
//               />
//               {documentFile?.length > 0 && (
//                 <div className="mt-2">
//                   <small className="text-muted">Selected files:</small>
//                   <ul className="list-unstyled">
//                     {documentFile.map((file, index) => (
//                       <li key={index}>
//                         <small>{file.name}</small>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </Form.Group>

//             <div className="d-flex justify-content-end gap-2">
//               <Button
//                 variant="primary"
//                 type="submit"
//                 disabled={loadingResponce}
//               >
//                 {loadingResponce ? "Submitting..." : "Submit Remark"}
//               </Button>
//               <Button
//                 variant="danger"
//                 onClick={() => {
//                   setShowResponceModal(false);
//                   setDocumentFile([]);
//                 }}
//                 disabled={loadingResponce}
//               >
//                 Cancel
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Message Modal */}
//       <Modal
//         show={showMessageModal}
//         onHide={() => {
//           if (messageModalContent.type !== "confirmation") {
//             closeCustomMessageModal();
//           }
//         }}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{messageModalContent.title}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <p>{messageModalContent.text}</p>

//             {messageModalContent.showDateInput &&
//               (messageModalContent.status === "approved" ||
//                 messageModalContent.status === "unitisnotsold" ||
//                 messageModalContent.status === "rejected") && (
//                 <Form.Group className="mt-3">
//                   <Form.Label>
//                     Status Date <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={statusUpdateDate}
//                     onChange={(e) => {
//                       setStatusUpdateDate(e.target.value);
//                     }}
//                     required
//                     min="2020-01-01"
//                     max={new Date().toISOString().split("T")[0]}
//                   />
//                   <Form.Text className="text-muted">
//                     Select the date when this status change is effective.
//                   </Form.Text>
//                 </Form.Group>
//               )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           {messageModalContent.type === "confirmation" && (
//             <Button
//               variant="primary"
//               onClick={() => {
//                 if (
//                   (messageModalContent.status === "approved" ||
//                     messageModalContent.status === "unitisnotsold" ||
//                     messageModalContent.status === "rejected") &&
//                   !statusUpdateDate
//                 ) {
//                   alert("Please select a date for status change.");
//                   return;
//                 }

//                 if (messageModalContent.confirmAction) {
//                   messageModalContent.confirmAction(statusUpdateDate);
//                 }
//               }}
//             >
//               Confirm
//             </Button>
//           )}

//           <Button
//             variant="success"
//             onClick={() => {
//               closeCustomMessageModal();
//             }}
//           >
//             {messageModalContent.type === "confirmation" ? "Cancel" : "Close"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// }

// export default AllLeadList;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaDownload, FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const imageAPIURL = process.env.REACT_APP_Image_URL;
const LIMIT = 10;

function AllLeadList() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchOrder, setSearchOrder] = useState("");
  const [searchMobile, setSearchMobile] = useState("");
  const [searchPlotName, setSearchPlotName] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedLead, setSelectedLead] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showResponceModal, setShowResponceModal] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [leadId, setLeadId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [responseText, setResponseText] = useState("");
  const [documentFile, setDocumentFile] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [userId, setUserId] = useState(null);
  const [statusUpdateDate, setStatusUpdateDate] = useState("");

  const [editFormData, setEditFormData] = useState({
    id: "",
    project_id: "",
    block_id: "",
    plot_id: "",
    customer_name: "",
    mobile: "",
    income_source: "",
    adhar_card_number: "",
    pan_card_number: "",
    adharfront: null,
    adharback: null,
    pancard: null,
    lead_date: "",
  });

  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const incomeSourceOptions = [
    { value: "", label: "Select Income Source" },
    { value: "business", label: "Business" },
    { value: "salaried", label: "Salaried" },
    { value: "rent", label: "Rent" },
    { value: "pension", label: "Pension" },
    { value: "other", label: "Other" },
  ];

  const [projectsForEdit, setProjectsForEdit] = useState([]);
  const [blocksForEdit, setBlocksForEdit] = useState([]);
  const [plotsForEdit, setPlotsForEdit] = useState([]);
  const [loadingDropdowns, setLoadingDropdowns] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
    showDateInput: false,
    status: "",
  });

  const [validationErrors, setValidationErrors] = useState({});
  const [socket, setSocket] = useState(null);

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 MESSAGE MODAL HELPERS
  // ═══════════════════════════════════════════
  const showCustomMessageModal = (
    title,
    text,
    type,
    confirmAction = null,
    showDateInput = false,
    status = ""
  ) => {
    if (
      showDateInput &&
      (status === "approved" || status === "unitisnotsold")
    ) {
      setStatusUpdateDate(new Date().toISOString().split("T")[0]);
    } else {
      setStatusUpdateDate("");
    }

    setMessageModalContent({
      title,
      text,
      type,
      confirmAction,
      showDateInput,
      status,
    });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = (keepDate = false) => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
      showDateInput: false,
      status: "",
    });
    if (!keepDate) setStatusUpdateDate("");
  };

  // ═══════════════════════════════════════════
  // 🔹 WEBSOCKET
  // ═══════════════════════════════════════════
  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_WS_URL);

    ws.onopen = () => console.log("WebSocket connection established");
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("Message from server:", data);
      } catch (e) {
        console.log("Raw message:", event.data);
      }
    };
    ws.onclose = () => console.log("WebSocket disconnected");
    ws.onerror = (err) => console.error("WebSocket error:", err);

    setSocket(ws);
    return () => ws.close();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH PROJECTS FOR EDIT
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchProjectsListForEdit = async () => {
      setLoadingDropdowns(true);
      try {
        const token = getAuthToken();
        if (!token) {
          setLoadingDropdowns(false);
          return;
        }

        const response = await fetch(`${API_URL}/project-list-block`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          setLoadingDropdowns(false);
          return;
        }
        const data = await response.json();
        setProjectsForEdit(data.data || []);
      } catch (err) {
        console.error("Fetch projects for edit error:", err);
      } finally {
        setLoadingDropdowns(false);
      }
    };

    fetchProjectsListForEdit();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH BLOCKS
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchBlocksListForEdit = async () => {
      if (editFormData.project_id) {
        setLoadingDropdowns(true);
        try {
          const token = getAuthToken();
          if (!token) {
            setLoadingDropdowns(false);
            return;
          }

          const response = await fetch(`${API_URL}/block-list-plot`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ project_id: editFormData.project_id }),
          });

          if (!response.ok) {
            setBlocksForEdit([]);
            setLoadingDropdowns(false);
            return;
          }

          const data = await response.json();
          setBlocksForEdit(data.data || []);
        } catch (err) {
          console.error("Fetch blocks for edit error:", err);
          setBlocksForEdit([]);
        } finally {
          setLoadingDropdowns(false);
        }
      } else {
        setBlocksForEdit([]);
        setPlotsForEdit([]);
      }
    };

    fetchBlocksListForEdit();
  }, [editFormData.project_id]);

  // ═══════════════════════════════════════════
  // 🔹 FETCH PLOTS
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchPlotsForEdit = async () => {
      if (editFormData.block_id) {
        setLoadingDropdowns(true);
        try {
          const token = getAuthToken();
          if (!token) {
            setLoadingDropdowns(false);
            return;
          }

          const response = await fetch(`${API_URL}/property-lead-plot-list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ block_id: editFormData.block_id }),
          });

          if (!response.ok) {
            setPlotsForEdit([]);
            setLoadingDropdowns(false);
            return;
          }

          const data = await response.json();
          setPlotsForEdit(data.data || []);
        } catch (err) {
          console.error("Fetch units for edit error:", err);
          setPlotsForEdit([]);
        } finally {
          setLoadingDropdowns(false);
        }
      } else {
        setPlotsForEdit([]);
      }
    };

    fetchPlotsForEdit();
  }, [editFormData.block_id]);

  // ═══════════════════════════════════════════
  // 🔹 FETCH LEADS (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchLeads = async (
    page = 1,
    query = "",
    orderid = "",
    mobile = "",
    status = "",
    plotname = ""
  ) => {
    setLoading(true);
    setError(null);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        setLoading(false);
        return;
      }

      let url = `${API_URL}/property-lead-list?page=${page}&limit=${LIMIT}`;
      if (mobile) url += `&mobile=${mobile}`;
      if (query) url += `&name=${query}`;
      if (orderid) url += `&orderid=${orderid}`;
      if (plotname) url += `&plotname=${plotname}`;
      if (status) url += `&status=${status}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          showCustomMessageModal(
            "Authorization Error",
            "Unauthorized: Please log in again.",
            "error"
          );
        }
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch leads.");
      }

      const data = await response.json();
      setLeads(data.data || []);
      setUserId(data?.data?.length > 0 ? data.data[0].creater_id : null);

      // ✅ Server se totalPages aur total dono set karo
      const pages = Number(data.totalPages) || 1;
      const total = Number(data.total) || (data.data?.length || 0);

      setTotalPages(pages);
      setTotalItems(total);
      setCurrentPage(Number(data.currentPage) || Number(page));
    } catch (err) {
      console.error("Fetch leads error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    fetchLeads(
      1,
      searchQuery.trim(),
      searchOrder,
      searchMobile.trim(),
      statusFilter,
      searchPlotName.trim()
    );
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setSearchOrder("");
    setSearchMobile("");
    setSearchPlotName("");
    setStatusFilter("");
    setCurrentPage(1);
    fetchLeads(1, "", "", "", "", "");
  };

  const handleStatusFilterChange = (status) => {
    setStatusFilter(status);
    setCurrentPage(1);
    fetchLeads(
      1,
      searchQuery.trim(),
      searchOrder,
      searchMobile.trim(),
      status,
      searchPlotName.trim()
    );
  };

  // ═══════════════════════════════════════════
  // 🔹 VIEW LEAD
  // ═══════════════════════════════════════════
  const handleViewLead = async (id) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/property-lead-edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch lead details.");
      }

      const data = await response.json();
      setSelectedLead(data.data);
      setShowViewModal(true);
    } catch (err) {
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT LEAD
  // ═══════════════════════════════════════════
  const handleEditLead = async (id) => {
    setLoadingEdit(true);
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/property-lead-edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch lead details for edit."
        );
      }

      const data = await response.json();
      const leadData = data.data;

      let formattedDate = "";
      if (leadData.date) {
        const [day, month, year] = leadData.date.split("-");
        formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
          2,
          "0"
        )}`;
      }

      setEditFormData({
        id: leadData.id,
        project_id: leadData.project_id,
        block_id: leadData.block_id,
        plot_id: leadData.plot_id,
        customer_name: leadData.customer_name,
        mobile: leadData.mobile,
        income_source: leadData.income_source,
        adhar_card_number: leadData.adhar_card_number,
        pan_card_number: leadData.pan_card_number,
        adharfront: leadData.adhar_front_image || null,
        adharback: leadData.adhar_back_image || null,
        pancard: leadData.pan_card_image || null,
        lead_date: formattedDate,
      });

      setShowEditModal(true);
    } catch (err) {
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoadingEdit(false);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files.length > 0) {
      setEditFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!editFormData.project_id) {
      errors.project_id = "Project is required";
      isValid = false;
    }
    if (!editFormData.block_id) {
      errors.block_id = "Block is required";
      isValid = false;
    }
    if (!editFormData.plot_id) {
      errors.plot_id = "Unit is required";
      isValid = false;
    }
    if (
      !editFormData.customer_name ||
      editFormData.customer_name.trim() === ""
    ) {
      errors.customer_name = "Customer name is required";
      isValid = false;
    }
    if (!editFormData.mobile) {
      errors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(editFormData.mobile)) {
      errors.mobile = "Mobile number must be 10 digits";
      isValid = false;
    }
    if (!editFormData.adhar_card_number) {
      errors.adhar_card_number = "Aadhaar number is required";
      isValid = false;
    } else if (!/^\d{12}$/.test(editFormData.adhar_card_number)) {
      errors.adhar_card_number = "Aadhaar must be 12 digits";
      isValid = false;
    }
    if (!editFormData.pan_card_number) {
      errors.pan_card_number = "PAN number is required";
      isValid = false;
    } else if (
      !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(editFormData.pan_card_number)
    ) {
      errors.pan_card_number = "Invalid PAN format (e.g., ABCDE1234F)";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  // ═══════════════════════════════════════════
  // 🔹 UPDATE LEAD
  // ═══════════════════════════════════════════
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoadingEdit(true);
    try {
      const token = getAuthToken();
      const formData = new FormData();

      for (const key in editFormData) {
        if (editFormData[key] !== null) {
          if (typeof editFormData[key] !== "string") {
            formData.append(key, editFormData[key]);
          } else if (
            key !== "adharfront" &&
            key !== "adharback" &&
            key !== "pancard"
          ) {
            formData.append(key, editFormData[key]);
          }
        }
      }

      const selectedProject = projectsForEdit.find(
        (p) => p.id === parseInt(editFormData.project_id)
      );
      if (selectedProject) formData.append("project_name", selectedProject.name);

      const selectedBlock = blocksForEdit.find(
        (b) => b.id === parseInt(editFormData.block_id)
      );
      if (selectedBlock) formData.append("block_name", selectedBlock.name);

      const selectedPlot = plotsForEdit.find(
        (p) => p.id === parseInt(editFormData.plot_id)
      );
      if (selectedPlot)
        formData.append("plot_name", selectedPlot.plot_shop_villa_no);

      const response = await fetch(`${API_URL}/property-lead-update`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update lead.");
      }

      const result = await response.json();
      if (result.success == "1") {
        showCustomMessageModal(
          "Success",
          result.message || "Lead updated successfully.",
          "success"
        );
        setShowEditModal(false);
        fetchLeads(currentPage);
      } else {
        showCustomMessageModal("Error", result.message, "error");
      }
    } catch (err) {
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoadingEdit(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 RESPONSE LEAD (ADD REMARK)
  // ═══════════════════════════════════════════
  const handleResponseLead = (id, orderid) => {
    setLeadId(id);
    setOrderId(orderid);
    setShowResponceModal(true);
  };

  const handleSubmitResponse = async (e) => {
    e.preventDefault();
    setLoadingResponce(true);
    try {
      const token = getAuthToken();
      const formData = new FormData();
      formData.append("lead_id", leadId);
      formData.append("response", responseText);

      documentFile.forEach((file) => {
        formData.append("document", file);
      });

      const response = await fetch(`${API_URL}/property-lead-response-store`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        showCustomMessageModal(
          "Success",
          "Response submitted successfully",
          "success"
        );
        setShowResponceModal(false);
        setResponseText("");
        setDocumentFile([]);

        if (socket && socket.readyState === WebSocket.OPEN) {
          const notificationPayload = {
            user_id: userId,
            type: "property_lead",
            message: `A response has been added for Property Lead ${leadId}.`,
            statusremark: null,
            remark: responseText,
            order_id: orderId,
            action_by: "admin",
            date: new Date().toISOString(),
          };
          socket.send(JSON.stringify(notificationPayload));
        }
      } else {
        throw new Error(data.message || "Failed to submit response");
      }
    } catch (err) {
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoadingResponce(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 BOOK PROPERTY
  // ═══════════════════════════════════════════
  const bookProperty = async (projectId, blockId, plotId, userId) => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/book-now`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          project_id: projectId,
          block_id: blockId,
          plot_id: plotId,
          user_id: userId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to book the property.");
      }
      const result = await response.json();
      showCustomMessageModal(
        "Success",
        result.message || "Property booked successfully.",
        "success"
      );
    } catch (err) {
      showCustomMessageModal("Error", err.message, "error");
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdate = (lead, newStatus) => {
    showCustomMessageModal(
      "Confirm Status Change",
      `Are you sure you want to change the status to ${formatStatus(
        newStatus
      )} on ${lead.date} Lead Date?`,
      "confirmation",
      async (selectedDate) => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const payload = { id: lead.id, status: newStatus };
          if (
            (newStatus === "approved" || newStatus === "unitisnotsold") &&
            selectedDate
          ) {
            payload.status_date = selectedDate;
          }

          const response = await fetch(
            `${API_URL}/property-lead-update-status`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(payload),
            }
          );

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update status.");
          }

          const result = await response.json();
          closeCustomMessageModal();
          showCustomMessageModal(
            "Success",
            result.message || "Lead status updated successfully.",
            "success"
          );
          fetchLeads(currentPage);

          if (newStatus === "approved") {
            await bookProperty(
              lead.project_id,
              lead.block_id,
              lead.plot_id,
              lead.creater_id
            );
          }

          if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(
              JSON.stringify({
                user_id: userId,
                type: "loan_lead",
                message: `Loan lead ${lead.order_id} status changed to ${newStatus}.`,
                statusremark: newStatus,
                remark: null,
                order_id: lead.order_id,
                action_by: "admin",
                date: new Date().toISOString(),
                status_date:
                  newStatus === "approved" || newStatus === "unitisnotsold"
                    ? selectedDate
                    : null,
              })
            );
          }
        } catch (err) {
          closeCustomMessageModal();
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      },
      newStatus === "approved" || newStatus === "unitisnotsold",
      newStatus
    );
  };

  // ═══════════════════════════════════════════
  // 🔹 REMARK HISTORY
  // ═══════════════════════════════════════════
  const handleRemarkList = (leadId, orderid, userId) => {
    navigate(`/lead-remarks/${leadId}/${orderid}/${userId}`);
  };

  // ═══════════════════════════════════════════
  // 🔹 HELPERS
  // ═══════════════════════════════════════════
  const getStatusStyle = (status) => {
    const styles = {
      pending: { bg: "#fef3e2", color: "#d97706" },
      inprocess: { bg: "#e8f1fb", color: "#1e5799" },
      approved: { bg: "#e7f9eb", color: "#059669" },
      available: { bg: "#e7f9eb", color: "#059669" },
      sold: { bg: "#feeaeb", color: "#dc2626" },
      new: { bg: "#fef3e2", color: "#d97706" },
      unitisnotsold: { bg: "#feeaeb", color: "#dc2626" },
      rejected: { bg: "#feeaeb", color: "#dc2626" },
      documentPending: { bg: "#fef3e2", color: "#d97706" },
      paymentPending: { bg: "#fef3e2", color: "#d97706" },
      notInterested: { bg: "#f1f5f9", color: "#64748b" },
      loanInprocess: { bg: "#e8f1fb", color: "#1e5799" },
      pattaInprocess: { bg: "#e8f1fb", color: "#1e5799" },
      termSheetPending: { bg: "#fef3e2", color: "#d97706" },
      agreementSignaturePending: { bg: "#fef3e2", color: "#d97706" },
      pattaApplicationFormPending: { bg: "#fef3e2", color: "#d97706" },
    };
    return styles[status] || { bg: "#f1f5f9", color: "#64748b" };
  };

  const formatStatus = (status) => {
    const statusMap = {
      new: "New",
      documentPending: "Document Pending",
      paymentPending: "Payment Pending",
      notInterested: "Not Interested",
      loanInprocess: "Loan In Process",
      pattaInprocess: "Patta In Process",
      termSheetPending: "Term Sheet Pending",
      agreementSignaturePending: "Agreement Signature Pending",
      pattaApplicationFormPending: "Patta Application Form Pending",
      approved: "Approved",
      unitisnotsold: "Unit is not sold",
      rejected: "Rejected",
    };
    return statusMap[status] || status;
  };

  // ═══════════════════════════════════════════
  // 🔹 EXPORT CSV
  // ═══════════════════════════════════════════
  const exportAllToExcel = async () => {
    setExporting(true);
    try {
      const token = getAuthToken();
      if (!token) {
        alert("Please login!");
        return;
      }

      const response = await fetch(
        `${API_URL}/lead-properties-new-exceldownload`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
          },
        }
      );

      if (!response.ok) {
        alert("Server Error: Unable to download!");
        return;
      }

      const csvData = await response.text();
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", `property_leads_${Date.now()}.csv`);
      link.click();
    } catch (error) {
      console.error("CSV Export Error:", error);
      alert("Export Failed! Try again");
    } finally {
      setExporting(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION PAGES GENERATOR
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);

    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3)
      pages.push("right-ellipsis");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading && leads.length === 0) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1800px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                📋
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  All Property Lead
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage and track all property leads ({totalItems} total)
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={exportAllToExcel}
                disabled={exporting}
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: exporting ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
                }}
              >
                <FaDownload /> {exporting ? "Exporting..." : "Export"}
              </button>

              <Link
                to="/create-lead"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Add Lead
              </Link>

              <Link
                to="/create-lead-by-uploading-csv"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Upload CSV
              </Link>

              <button
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filters */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Lead ID</label>
                  <input
                    type="text"
                    placeholder="Lead ID"
                    value={searchOrder}
                    onChange={(e) => setSearchOrder(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Name</label>
                  <input
                    type="text"
                    placeholder="Name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Mobile</label>
                  <input
                    type="text"
                    placeholder="Customer Mobile"
                    value={searchMobile}
                    onChange={(e) => setSearchMobile(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Unit Number</label>
                  <input
                    type="text"
                    placeholder="Unit Number"
                    value={searchPlotName}
                    onChange={(e) => setSearchPlotName(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div style={{ flex: 1, minWidth: "160px" }}>
                  <label style={labelStyle}>Status</label>
                  <select
                    value={statusFilter}
                    onChange={(e) => handleStatusFilterChange(e.target.value)}
                    style={inputStyle}
                  >
                    <option value="">All Status</option>
                    {[
                      "new",
                      "documentPending",
                      "paymentPending",
                      "notInterested",
                      "loanInprocess",
                      "pattaInprocess",
                      "termSheetPending",
                      "agreementSignaturePending",
                      "pattaApplicationFormPending",
                      "approved",
                      "unitisnotsold",
                      "rejected",
                    ].map((status) => (
                      <option key={status} value={status}>
                        {formatStatus(status)}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={handleSearchClick}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    onClick={handleClearSearch}
                    style={{
                      padding: "10px 18px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      color: "#64748b",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}

            {/* Error */}
            {error && (
              <div
                style={{
                  background: "#feeaeb",
                  border: "1.5px solid #fecaca",
                  color: "#991b1b",
                  borderRadius: "12px",
                  padding: "14px 18px",
                  marginBottom: "20px",
                  fontWeight: "600",
                  fontSize: "13.5px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span>⚠️ {error}</span>
                <button
                  onClick={() => fetchLeads()}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "8px",
                    border: "none",
                    background: "#dc2626",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                >
                  Retry
                </button>
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: "1500px",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Associate Name",
                      "Mobile",
                      "Lead ID",
                      "Project",
                      "Block",
                      "Unit",
                      "Customer",
                      "Mobile No.",
                      "Income",
                      "Lead Date",
                      "Status",
                      "Remark",
                      "Actions",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {leads?.length > 0 ? (
                    leads.map((lead, i) => (
                      <tr
                        key={lead.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>
                          {(currentPage - 1) * LIMIT + i + 1}
                        </td>
                        <td style={cellDark}>{lead.creator_username || "-"}</td>
                        <td style={cellGray}>{lead.creator_mobile || "-"}</td>
                        <td style={cellText}>{lead.order_id || "-"}</td>
                        <td style={cellDark}>{lead.project_name || "-"}</td>
                        <td style={cellGray}>{lead.block_name || "-"}</td>
                        <td style={cellText}>{lead.plot_name || "-"}</td>
                        <td style={cellDark}>{lead.customer_name || "-"}</td>
                        <td style={cellGray}>{lead.mobile || "-"}</td>
                        <td style={cellGray}>{lead.income_source || "-"}</td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {lead.date || "-"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <select
                            value={lead.status}
                            onChange={(e) =>
                              handleStatusUpdate(lead, e.target.value)
                            }
                            disabled={
                              lead.status === "approved" ||
                              lead.status === "notInterested" ||
                              lead.status === "unitisnotsold"
                            }
                            style={{
                              padding: "6px 12px",
                              borderRadius: "20px",
                              border: "none",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              cursor:
                                lead.status === "approved" ||
                                lead.status === "notInterested" ||
                                lead.status === "unitisnotsold"
                                  ? "not-allowed"
                                  : "pointer",
                              background: getStatusStyle(lead.status).bg,
                              color: getStatusStyle(lead.status).color,
                              outline: "none",
                              minWidth: "150px",
                            }}
                          >
                            {[
                              "new",
                              "documentPending",
                              "paymentPending",
                              "notInterested",
                              "loanInprocess",
                              "pattaInprocess",
                              "termSheetPending",
                              "agreementSignaturePending",
                              "pattaApplicationFormPending",
                              "approved",
                              "unitisnotsold",
                              "rejected",
                            ].map((status) => (
                              <option key={status} value={status}>
                                {formatStatus(status)}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <button
                            onClick={() =>
                              handleResponseLead(lead.id, lead.order_id)
                            }
                            disabled={loadingResponce}
                            style={{
                              padding: "7px 14px",
                              borderRadius: "8px",
                              border: "none",
                              background:
                                "linear-gradient(135deg, #059669, #047857)",
                              color: "#ffffff",
                              fontSize: "12px",
                              fontWeight: "700",
                              cursor: loadingResponce
                                ? "not-allowed"
                                : "pointer",
                              whiteSpace: "nowrap",
                              boxShadow: "0 4px 12px rgba(5, 150, 105, 0.25)",
                            }}
                          >
                            Add Remark
                          </button>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <div className="dropdown">
                            <button
                              className="btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-bs-boundary="viewport"
                              data-bs-popper-config='{"strategy":"fixed"}'
                              aria-expanded="false"
                              style={{
                                background: "#f8fafc",
                                border: "1.5px solid #e2e8f0",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#1e5799",
                                padding: 0,
                              }}
                            >
                              <BsThreeDots size={18} />
                            </button>
                            <ul
                              className="dropdown-menu"
                              style={{
                                zIndex: 9999,
                                borderRadius: "14px",
                                border: "none",
                                padding: "8px",
                                boxShadow:
                                  "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                minWidth: "230px",
                                marginTop: "8px",
                                background: "#ffffff",
                              }}
                            >
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleViewLead(lead.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e8f1fb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e8f1fb", "#1e5799")}>
                                    <FaEye size={13} />
                                  </span>
                                  View Details
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleEditLead(lead.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e7f9eb", "#059669")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Edit Lead
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleRemarkList(
                                      lead.id,
                                      lead.order_id,
                                      userId
                                    )
                                  }
                                  style={{ ...dropdownItem, color: "#7c3aed" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#f3e8ff";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#f3e8ff", "#7c3aed")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Remark History
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="14"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No leads found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }

                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 VIEW MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        size="lg"
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            📋 Property Lead Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          {selectedLead ? (
            <>
              <h6 style={sectionHeader}>👤 Customer Details</h6>
              <Row className="mb-3">
                <Col md={6}>
                  <strong style={labelColor}>Project Name:</strong>
                  <p style={textDark}>{selectedLead.project_name || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Block Name:</strong>
                  <p style={textDark}>{selectedLead.block_name || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Unit Number:</strong>
                  <p style={textDark}>{selectedLead.plot_name || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Customer Name:</strong>
                  <p style={textDark}>{selectedLead.customer_name || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Mobile Number:</strong>
                  <p style={textDark}>{selectedLead.mobile || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Income Source:</strong>
                  <p style={textDark}>{selectedLead.income_source || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Aadhaar Card:</strong>
                  <p style={textDark}>{selectedLead.adhar_card_number || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>PAN Card:</strong>
                  <p style={textDark}>{selectedLead.pan_card_number || "-"}</p>
                </Col>
              </Row>

              <hr
                style={{
                  margin: "20px 0",
                  border: "none",
                  borderTop: "1.5px dashed #e2e8f0",
                }}
              />
              <h6 style={sectionHeader}>📷 Document Verification</h6>
              <Row>
                {[
                  {
                    label: "Aadhaar Front",
                    img: selectedLead.adhar_front_image,
                  },
                  { label: "Aadhaar Back", img: selectedLead.adhar_back_image },
                  { label: "PAN Card", img: selectedLead.pan_card_image },
                ].map((doc, i) => (
                  <Col md={4} key={i} className="mb-3">
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#1e3a5f",
                        marginBottom: "8px",
                      }}
                    >
                      {doc.label}
                    </p>
                    {doc.img ? (
                      <a
                        href={`${imageAPIURL}/lead/${doc.img}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`${imageAPIURL}/lead/${doc.img}`}
                          alt={doc.label}
                          style={{
                            width: "100%",
                            maxHeight: "150px",
                            objectFit: "cover",
                            borderRadius: "10px",
                            border: "1.5px solid #e2e8f0",
                            cursor: "pointer",
                          }}
                          onError={(e) => {
                            e.target.src =
                              "https://placehold.co/300x200/cccccc/666666?text=No+Image";
                          }}
                        />
                      </a>
                    ) : (
                      <div
                        style={{
                          padding: "30px 10px",
                          background: "#f8fafc",
                          border: "1.5px dashed #e2e8f0",
                          borderRadius: "10px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontSize: "12px",
                        }}
                      >
                        No image available
                      </div>
                    )}
                  </Col>
                ))}
              </Row>
            </>
          ) : (
            <p>Loading details...</p>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1.5px solid #e2e8f0" }}>
          <Button
            variant="secondary"
            onClick={() => setShowViewModal(false)}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "8px 24px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        size="lg"
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Property Lead
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form onSubmit={handleUpdateSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Project Name</Form.Label>
                  <Form.Select
                    name="project_id"
                    value={editFormData.project_id}
                    onChange={handleEditFormChange}
                    disabled={loadingDropdowns || projectsForEdit.length === 0}
                    required
                    style={inputStyle}
                  >
                    <option value="">Select a Project</option>
                    {projectsForEdit.map((project) => (
                      <option key={project.id} value={project.id}>
                        {project.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Block Name</Form.Label>
                  <Form.Select
                    name="block_id"
                    value={editFormData.block_id}
                    onChange={handleEditFormChange}
                    disabled={
                      !editFormData.project_id ||
                      loadingDropdowns ||
                      blocksForEdit.length === 0
                    }
                    required
                    style={inputStyle}
                  >
                    <option value="">Select a Block</option>
                    {blocksForEdit.map((block) => (
                      <option key={block.id} value={block.id}>
                        {block.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Unit Number</Form.Label>
                  <Form.Select
                    name="plot_id"
                    value={editFormData.plot_id}
                    onChange={handleEditFormChange}
                    disabled={!editFormData.block_id || loadingDropdowns}
                    required
                    style={inputStyle}
                  >
                    <option value="">Select Unit</option>
                    {plotsForEdit.map((plot) => (
                      <option key={plot.id} value={plot.id}>
                        {plot.plot_shop_villa_no}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Customer Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="customer_name"
                    value={editFormData.customer_name}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Mobile Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="mobile"
                    value={editFormData.mobile}
                    onChange={handleEditFormChange}
                    maxLength={10}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Income Source</Form.Label>
                  <Form.Select
                    name="income_source"
                    value={editFormData.income_source}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  >
                    {incomeSourceOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Aadhaar Card Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="adhar_card_number"
                    value={editFormData.adhar_card_number}
                    onChange={handleEditFormChange}
                    maxLength={12}
                    isInvalid={!!validationErrors.adhar_card_number}
                    required
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.adhar_card_number}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>PAN Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="pan_card_number"
                    value={editFormData.pan_card_number}
                    onChange={handleEditFormChange}
                    isInvalid={!!validationErrors.pan_card_number}
                    required
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.pan_card_number}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Booking Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="lead_date"
                    value={editFormData.lead_date}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Aadhaar Front</Form.Label>
                  <Form.Control
                    type="file"
                    name="adharfront"
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Aadhaar Back</Form.Label>
                  <Form.Control
                    type="file"
                    name="adharback"
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>PAN Card</Form.Label>
                  <Form.Control
                    type="file"
                    name="pancard"
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              variant="primary"
              type="submit"
              disabled={loadingEdit}
              className="w-100"
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: loadingEdit
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: loadingEdit
                  ? "none"
                  : "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              {loadingEdit ? "Updating..." : "Update Lead"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 RESPONSE MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showResponceModal}
        onHide={() => {
          setShowResponceModal(false);
          setDocumentFile([]);
        }}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            💬 Add Remark
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <Form onSubmit={handleSubmitResponse}>
            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Remark Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={responseText}
                onChange={(e) => setResponseText(e.target.value)}
                required
                style={{ ...inputStyle, resize: "vertical" }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Documents</Form.Label>
              <Form.Control
                type="file"
                accept="image/*,.pdf"
                onChange={(e) => setDocumentFile(Array.from(e.target.files))}
                multiple
                style={inputStyle}
              />
              {documentFile?.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  <small
                    style={{
                      color: "#64748b",
                      fontWeight: "600",
                      fontSize: "11.5px",
                    }}
                  >
                    Selected files:
                  </small>
                  <ul
                    style={{
                      marginTop: "6px",
                      paddingLeft: "18px",
                      marginBottom: 0,
                    }}
                  >
                    {documentFile.map((file, index) => (
                      <li
                        key={index}
                        style={{
                          fontSize: "12px",
                          color: "#334155",
                        }}
                      >
                        {file.name}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              disabled={loadingResponce}
              className="w-100"
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: loadingResponce
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: loadingResponce
                  ? "none"
                  : "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              {loadingResponce ? "Submitting..." : "Submit Remark"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 MESSAGE MODAL — Solid #1e5799 */}
      {/* ═══════════════════════════════════════════ */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 99999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
              }}
            >
              <div
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={() => {
                    if (messageModalContent.type !== "confirmation") {
                      closeCustomMessageModal();
                    }
                  }}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
              >
                <p style={{ margin: 0 }}>{messageModalContent.text}</p>

                {messageModalContent.showDateInput &&
                  (messageModalContent.status === "approved" ||
                    messageModalContent.status === "unitisnotsold" ||
                    messageModalContent.status === "rejected") && (
                    <Form.Group className="mt-3">
                      <Form.Label style={labelStyle}>
                        Status Date <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={statusUpdateDate}
                        onChange={(e) => setStatusUpdateDate(e.target.value)}
                        required
                        min="2020-01-01"
                        max={new Date().toISOString().split("T")[0]}
                        style={inputStyle}
                      />
                      <Form.Text
                        style={{
                          color: "#64748b",
                          fontSize: "11.5px",
                          fontWeight: "500",
                        }}
                      >
                        Select the date when this status change is effective.
                      </Form.Text>
                    </Form.Group>
                  )}
              </div>
              <div
                className="modal-footer"
                style={{
                  borderTop: "1.5px solid #e2e8f0",
                  padding: "16px 24px",
                  gap: "10px",
                }}
              >
                {messageModalContent.type === "confirmation" ? (
                  <>
                    <button
                      type="button"
                      onClick={closeCustomMessageModal}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (
                          (messageModalContent.status === "approved" ||
                            messageModalContent.status === "unitisnotsold" ||
                            messageModalContent.status === "rejected") &&
                          !statusUpdateDate
                        ) {
                          alert("Please select a date for status change.");
                          return;
                        }
                        if (messageModalContent.confirmAction) {
                          messageModalContent.confirmAction(statusUpdateDate);
                        }
                      }}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background: "#1e5799",
                        color: "#ffffff",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                      }}
                    >
                      Confirm
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    onClick={closeCustomMessageModal}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "#1e5799",
                      color: "#ffffff",
                      fontSize: "13px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                    }}
                  >
                    OK
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const labelColor = { color: "#1e5799" };
const textDark = { margin: "4px 0", color: "#334155" };

const sectionHeader = {
  fontWeight: "800",
  color: "#1e5799",
  marginBottom: "14px",
  fontSize: "15px",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };
const cellText = { padding: "12px", fontWeight: "600", color: "#1e5799" };

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default AllLeadList;